export const kmKH: { [k: string]: string } = {
  'ជំងឺអាលែកហ្ស៊ី/អាលែកហ្ស៊ីសត្វ-សត្វល្អិត':
    'Allergies/AnimalAndInsectAllergies',
  'ជំងឺអាលែកហ្ស៊ី/អាលែកហ្ស៊ីចំណីអាហារ': 'Allergies/FoodAllergies',
  'ជំងឺអាលែកហ្ស៊ី/អាលែកហ្ស៊ីភ្នែក-ច្រុះ': 'Allergies/NoseAndEye',
  'ជំងឺអាលែកហ្ស៊ី/អាលែកហ្ស៊ីផ្សេងទៀត': 'Allergies/OtherAllergies',
  'ជំងឺអាលែកហ្ស៊ី/អាលែកហ្ស៊ីស្បែក': 'Allergies/SkinAllergies',
  ជំងឺអាលែកហ្ស៊ី: 'Allergies',
  'ជំងឺឈាម/ជំងឺស្លេកស្លាំង': 'BloodDisorders/Anemia',
  'ជំងឺឈាម/ជំងឺអេម៉ូហ្វីលៀ': 'BloodDisorders/Hemophilia',
  'ជំងឺឈាម/ជំងឺឈាមផ្សេងទៀត': 'BloodDisorders/OtherBloodDisorders',
  'ជំងឺឈាម/ជំងឺវិបត្តិគ្រាប់ឈាមប្លាកែត': 'BloodDisorders/PlateletDisorder',
  'ជំងឺឈាម/ជំងឺតាឡាសេមៀរ': 'BloodDisorders/Thalassemia',
  'ជំងឺឈាម/ជំងឺវិបត្តិគ្រាប់ឈាមស': 'BloodDisorders/WhiteBloodCellDisorder',
  ជំងឺឈាម: 'BloodDisorders',
  'ខួរក្បាលនិងប្រព័ន្ធប្រសាទ/ជំងឺខួរក្បាលនិងឆ្អឹងខ្នង':
    'BrainAndNervousSystem/BrainAndSpineDisorders',
  'ខួរក្បាលនិងប្រព័ន្ធប្រសាទ/ជំងឺបាត់ការចងចាំនិងវង្វេងវង្វាន់':
    'BrainAndNervousSystem/DementiaAndAlzheimerSDisease',
  'ខួរក្បាលនិងប្រព័ន្ធប្រសាទ/ឈឺក្បាលនិងឈឺក្បាលប្រកាំង':
    'BrainAndNervousSystem/HeadachesAndMigraines',
  'ខួរក្បាលនិងប្រព័ន្ធប្រសាទ/ជំងឺប៉ះពាល់បេះដូងនិងខួរក្បាល':
    'BrainAndNervousSystem/MultipleSclerosis',
  'ខួរក្បាលនិងប្រព័ន្ធប្រសាទ/បញ្ហាខួរក្បាលនិងប្រព័ន្ធប្រសាទផ្សេងទៀត':
    'BrainAndNervousSystem/OtherBrainNsIssues',
  'ខួរក្បាលនិងប្រព័ន្ធប្រសាទ/ជំងឺប៉ាគីនសិន':
    'BrainAndNervousSystem/ParkinsonSDisease',
  'ខួរក្បាលនិងប្រព័ន្ធប្រសាទ/ជំងឺប្រព័ន្ធប្រសាទ':
    'BrainAndNervousSystem/PeripheralNervousSystemDisorders',
  'ខួរក្បាលនិងប្រព័ន្ធប្រសាទ/ជំងឺប្រកាច់':
    'BrainAndNervousSystem/SeizureDisorders',
  'ខួរក្បាលនិងប្រព័ន្ធប្រសាទ/គ្រោះថ្នាក់សរសៃឈាម':
    'BrainAndNervousSystem/StrokeAndAneurysm',
  ខួរក្បាលនិងប្រព័ន្ធប្រសាទ: 'BrainAndNervousSystem',
  'ជំងឺមហារីក/មហារីកប្លោកនោម': 'Cancer/BladderCancer',
  'ជំងឺមហារីក/មហារីកឆ្អឹង': 'Cancer/BoneCancer',
  'ជំងឺមហារីក/ដុំមហារីកខួរក្បាល': 'Cancer/BrainTumors',
  'ជំងឺមហារីក/មហារីកសុដន់': 'Cancer/BreastCancer',
  'ជំងឺមហារីក/មហារីកមាត់ស្បូន': 'Cancer/CervicalCancer',
  'ជំងឺមហារីក/មហារីកពោះវៀនធំ': 'Cancer/ColorectalCancer',
  'ជំងឺមហារីក/មហារីកក្បាលនិងក': 'Cancer/HeadAndNeckCancer',
  'ជំងឺមហារីក/មហារីកឈាម': 'Cancer/Leukemia',
  'ជំងឺមហារីក/មហារីកថ្លើម': 'Cancer/LiverCancer',
  'ជំងឺមហារីក/មហារីកសួត': 'Cancer/LungCancer',
  'ជំងឺមហារីក/មហារីកកូនកណ្ដុរ': 'Cancer/Lymphoma',
  'ជំងឺមហារីក/មហារីកផ្សេងទៀត': 'Cancer/OtherCancers',
  'ជំងឺមហារីក/មហារីកក្រពេញអូវែ': 'Cancer/OvarianCancer',
  'ជំងឺមហារីក/មហារីកលំពែង': 'Cancer/PancreaticCancer',
  'ជំងឺមហារីក/មហារីកក្រពេញប្រូស្តាត': 'Cancer/ProstateCancer',
  'ជំងឺមហារីក/មហារីកស្បែក': 'Cancer/SkinCancer',
  'ជំងឺមហារីក/មហារីកក្រពះ': 'Cancer/StomachCancer',
  'ជំងឺមហារីក/មហារីកក្រពេញទីរ៉ូអ៊ីត': 'Cancer/ThyroidCancer',
  ជំងឺមហារីក: 'Cancer',
  'ជំងឺទឹកនោមផ្អែម/ផលវិបាកជំងឺទឹកនោមផ្អែម': 'Diabetes/DiabetesComplications',
  'ជំងឺទឹកនោមផ្អែម/hello-type-1': 'Diabetes/Type1Diabetes',
  'ជំងឺទឹកនោមផ្អែម/ជំងឺទឹកនោមផ្អែមប្រភេទ២': 'Diabetes/Type2Diabetes',
  ជំងឺទឹកនោមផ្អែម: 'Diabetes',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ហើមពោះ': 'DigestiveHealth/BloatingAndGas',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ជំងឺទល់លាមក': 'DigestiveHealth/Constipation',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ជំងឺរាក': 'DigestiveHealth/Diarrhea',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ជំងឺថង់ប្រមាត់':
    'DigestiveHealth/GallbladderDisease',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ការបង្ករោគក្នុងពោះវៀន': 'DigestiveHealth/Gastritis',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/រលាកក្រពះពោះវៀន': 'DigestiveHealth/Gastroenteritis',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ចាល់អាស៊ីដក្រពះ': 'DigestiveHealth/Gerd',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ក្រហាយទ្រូង': 'DigestiveHealth/Heartburn',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ជំងឺឫសដូងបាត': 'DigestiveHealth/Hemorrhoids',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/រលាកពោះវៀនរ៉ាំរ៉ៃ':
    'DigestiveHealth/InflammatoryBowelDisease',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ជំងឺថ្លើម': 'DigestiveHealth/LiverDiseases',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/បញ្ហាប្រព័ន្ធរំលាយអាហារផ្សេងទៀត':
    'DigestiveHealth/OtherDigestiveHealthIssues',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ដំបៅកក្រពះ': 'DigestiveHealth/PepticUlcerDisease',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ការលូតលាស់បាក់តេរីក្នុងពោះវៀន':
    'DigestiveHealth/Sibo',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/រលាកក្រពះ': 'DigestiveHealth/StomachFlu',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/ដំបៅក្រពះ': 'DigestiveHealth/StomachUlcer',
  សុខភាពប្រព័ន្ធរំលាយអាហារ: 'DigestiveHealth',
  'សុខភាពប្រព័ន្ធរំលាយអាហារ/រលាកពោះវៀន':
    'DigestiveHealth/IrritableBowelSyndrome',
  ឱសថនិងអាហារបំប៉ន: 'DrugsAndSupplements',
  'ជំងឺត្រចៀក-ច្រមុះ-និងបំពង់ក/ជំងឺត្រចៀក': 'Ent/EarConditions',
  'ជំងឺត្រចៀក-ច្រមុះ-និងបំពង់ក/ជំងឺច្រមុះ': 'Ent/NoseConditions',
  'ជំងឺត្រចៀក-ច្រមុះ-និងបំពង់ក/ជំងឺបំពង់ក': 'Ent/ThroatConditions',
  'ជំងឺត្រចៀក-ច្រមុះ-និងបំពង់ក': 'Ent',
  'សុខភាពភ្នែក/ភ្នែកឡើងបាយ': 'EyeHealth/Cataracts',
  'សុខភាពភ្នែក/ការថែទាំភ្នែក': 'EyeHealth/EyeCare',
  'សុខភាពភ្នែក/ជំងឺភ្នែក': 'EyeHealth/EyeDiseases',
  'សុខភាពភ្នែក/ជំងឺទឹកដក់បាតភ្នែក': 'EyeHealth/Glaucoma',
  'សុខភាពភ្នែក/បញ្ហាភ្នែកផ្សេងទៀត': 'EyeHealth/OtherEyeIssues',
  'សុខភាពភ្នែក/ស្រវាំងភ្នែក': 'EyeHealth/VisionImpairmentAndLoss',
  សុខភាពភ្នែក: 'EyeHealth',
  'សុខភាពទូទៅ/ចំណេះដឹងទូទៅ': 'Health/GeneralHealthKnowledge',
  'សុខភាពទូទៅ/ធានារ៉ាប់រង': 'Health/HealthInsurance',
  'សុខភាពទូទៅ/ព័ត៌មាន': 'Health/HealthNews',
  'សុខភាពទូទៅ/ការពិនិត្យរបស់គ្រូពេទ្យនិងមន្ទីរពេទ្យ':
    'Health/HospitalAndDoctorReviews',
  'សុខភាពទូទៅ/ការព្យាបាលនិងវះកាត់': 'Health/MedicalProceduresAndSurgeries',
  'សុខភាពទូទៅ/តេស្ដសុខភាព': 'Health/MedicalTests',
  'សុខភាពទូទៅ/រោគសញ្ញា': 'Health/Symptoms',
  សុខភាពទូទៅ: 'Health',
  'លំហាត់ប្រាណ/លំហាត់ជំនួយបេះដូង': 'HealthFitness/CardioAndEndurance',
  'លំហាត់ប្រាណ/ជំរុញការហាត់ប្រាណ': 'HealthFitness/FitnessMotivation',
  'លំហាត់ប្រាណ/ពត់ខ្លួននិងរក្សារាង': 'HealthFitness/FlexibilityBalance',
  'លំហាត់ប្រាណ/លំហាត់ប្រាណផ្សេងទៀត': 'HealthFitness/OtherFitnessActivities',
  'លំហាត់ប្រាណ/របួសពីការលេងកីឡា': 'HealthFitness/SportsInjuries',
  'លំហាត់ប្រាណ/លំហាត់យកសាច់ដុំ': 'HealthFitness/StrengthTraining',
  'លំហាត់ប្រាណ/លំហាត់សម្រកទម្ងន់': 'HealthFitness/WeightLossExercises',
  លំហាត់ប្រាណ: 'HealthFitness',
  'រង្វាស់សុខភាព/គណនា-bmi': 'HealthTools/BmiCalculator',
  'រង្វាស់សុខភាព/គណនា-bmr': 'HealthTools/BmrCalculator',
  'សុខភាពមនុស្សចាស់/លំហាត់ប្រាណសម្រាប់មនុស្សចាស់': 'HealthyAging/ActiveAging',
  'សុខភាពមនុស្សចាស់/សុខភាពរាងកាយ': 'HealthyAging/AgingBody',
  'សុខភាពមនុស្សចាស់/សុខភាពផ្លូវចិត្តមនុស្សចាស់': 'HealthyAging/AgingMind',
  'សុខភាពមនុស្សចាស់/ជំងឺឧស្សាហ៍កើតលើមនុស្សចាស់':
    'HealthyAging/CommonAgingConditions',
  'សុខភាពមនុស្សចាស់/របបអាហារសម្រាប់មនុស្សចាស់':
    'HealthyAging/NutritionForAging',
  សុខភាពមនុស្សចាស់: 'HealthyAging',
  'របបអាហារ/គ្រប់គ្រងអាហារ-និងទម្ងន់': 'HealthyEating/DietAndWeightLoss',
  'របបអាហារ/រូបមន្តសុខភាព': 'HealthyEating/HealthyRecipes',
  'របបអាហារ/អាហារូបត្ថម្ភ': 'HealthyEating/NutritionFacts',
  'របបអាហារ/លើសទម្ងន់': 'HealthyEating/Obesity',
  'របបអាហារ/គន្លឹះពីអាហារសុខភាពផ្សេងទៀត':
    'HealthyEating/OtherHealthyEatingTips',
  'របបអាហារ/របបអាហារពិសេស': 'HealthyEating/SpecialDiets',
  'របបអាហារ/អាហារសម្រាប់ហាត់កីឡា': 'HealthyEating/SportsNutrition',
  របបអាហារ: 'HealthyEating',
  'ទម្លាប់ល្អ/វិធី​សង្គ្រោះបឋម': 'HealthyHabits/FirstAid',
  'ទម្លាប់ល្អ/អនាម័យទូទៅ': 'HealthyHabits/GeneralHygiene',
  'ទម្លាប់ល្អ/ការផ្ដាច់បារី': 'HealthyHabits/QuitSmoking',
  ទម្លាប់ល្អ: 'HealthyHabits',
  'សុខភាពផ្លូវចិត្ត/ការញៀន': 'HealthyMind/Addiction',
  'សុខភាពផ្លូវចិត្ត/ជំងឺថប់បារម្ភ': 'HealthyMind/AnxietyDisorder',
  'សុខភាពផ្លូវចិត្ត/បញ្ហាការហូបចុក': 'HealthyMind/EatingDisorders',
  'សុខភាពផ្លូវចិត្ត/ទំនាក់ទំនងល្អ': 'HealthyMind/HealthyRelationships',
  'សុខភាពផ្លូវចិត្ត/ការធ្លាក់ចុះផ្នែកអារម្មណ៍': 'HealthyMind/MoodDisorder',
  'សុខភាពផ្លូវចិត្ត/បញ្ហាផ្លូវចិត្តផ្សេងទៀត':
    'HealthyMind/OtherMentalHealthIssues',
  'សុខភាពផ្លូវចិត្ត/វិធីបំបាត់ស្ត្រេស': 'HealthyMind/StressManagement',
  'សុខភាពផ្លូវចិត្ត/វិធីបញ្ចៀសការសម្លាប់ខ្លួន': 'HealthyMind/SuicidePrevention',
  សុខភាពផ្លូវចិត្ត: 'HealthyMind',
  'ដំណេក/ដំណេកស្កប់ស្កល់': 'HealthySleep/AGoodNightSSleep',
  'ដំណេក/បញ្ហាគេងមិនលក់': 'HealthySleep/Insomnia',
  'ដំណេក/បញ្ហាគេងបាត់ដង្ហើម': 'HealthySleep/SleepApnea',
  'ដំណេក/បញ្ហាដំណេកផ្សេងទៀត': 'HealthySleep/SleepDisorders',
  ដំណេក: 'HealthySleep',
  'សុខភាពបេះដូង/ក្រិនសរសៃឈាមបេះដូង': 'HeartHealth/Atherosclerosis',
  'សុខភាពបេះដូង/ជំងឺសាច់ដុំបេះដូង': 'HeartHealth/Cardiomyopathy',
  'សុខភាពបេះដូង/លើសជាតិខ្លាញ់': 'HeartHealth/Cholesterol',
  'សុខភាពបេះដូង/ជំងឺបេះដូងពីកំណើត': 'HeartHealth/CongenitalHeartDisease',
  'សុខភាពបេះដូង/ជំងឺសរសៃឈាមបេះដូង': 'HeartHealth/CoronaryArteryDisease',
  'សុខភាពបេះដូង/បេះដូងដើរខុសចង្វាក់': 'HeartHealth/HeartArrhythmias',
  'សុខភាពបេះដូង/ជំងឺបេះដូង': 'HeartHealth/HeartDisease',
  'សុខភាពបេះដូង/ខូចបេះដូង': 'HeartHealth/HeartFailure',
  'សុខភាពបេះដូង/ការបង្ករោគលើបេះដូង': 'HeartHealth/HeartInfections',
  'សុខភាពបេះដូង/ប្រឹសបេះដូង': 'HeartHealth/HeartValve',
  'សុខភាពបេះដូង/ជំងឺលើសសម្ពាធឈាម': 'HeartHealth/Hypertension',
  'សុខភាពបេះដូង/បញ្ហាបេះដូងផ្សេងទៀត': 'HeartHealth/OtherCardiovascularIssues',
  សុខភាពបេះដូង: 'HeartHealth',
  'ឱសថរុក្ខជាតិនិងថ្នាំបន្ទាប់បន្សំ/ថ្នាំបន្ទាប់បន្សំ':
    'HerbalsAndAlternatives/AlternativeMedicines',
  'ឱសថរុក្ខជាតិនិងថ្នាំបន្ទាប់បន្សំ/ឱសថរុក្ខជាតិ':
    'HerbalsAndAlternatives/HerbalMedicines',
  ឱសថរុក្ខជាតិនិងថ្នាំបន្ទាប់បន្សំ: 'HerbalsAndAlternatives',
  'ជំងឺឆ្លង/ជំងឺឆ្លងតាមប្រព័ន្ធខ្យល់ដង្ហើម':
    'InfectiousDiseases/AirborneInfections',
  'ជំងឺឆ្លង/វីរុសកូរ៉ូណា': 'InfectiousDiseases/Coronavirus',
  'ជំងឺឆ្លង/ជំងឺគ្រុនឈាម': 'InfectiousDiseases/Dengue',
  'ជំងឺឆ្លង/ពុលចំណីអាហារ': 'InfectiousDiseases/FoodborneInfections',
  'ជំងឺឆ្លង/ជំងឺរើម': 'InfectiousDiseases/Herpes',
  'ជំងឺឆ្លង/ជំងឺឆ្លងពីសត្វល្អិត': 'InfectiousDiseases/InfectionsFromInsects',
  'ជំងឺឆ្លង/ជំងឺរលាកស្រោមខួរ': 'InfectiousDiseases/Meningitis',
  'ជំងឺឆ្លង/ឆ្លងបាក់តេរីផ្សេងៗ': 'InfectiousDiseases/OtherBacterialInfections',
  'ជំងឺឆ្លង/ជំងឺឆ្លងពីវីរុសផ្សេងៗ': 'InfectiousDiseases/OtherViralInfections',
  'ជំងឺឆ្លង/ឆ្លងរោគប្រព័ន្ធផ្លូវដង្ហើម':
    'InfectiousDiseases/RespiratoryInfections',
  'ជំងឺឆ្លង/ជំងឺគ្រុនពោះវៀន': 'InfectiousDiseases/TyphoidFever',
  'ជំងឺឆ្លង/ជំងឺហ្ស៊ីកា': 'InfectiousDiseases/Zika',
  ជំងឺឆ្លង: 'InfectiousDiseases',
  'សុខភាពបុរស/លិង្គមិនឡើងរឹង': 'MenSHealth/ErectileDysfunction',
  'សុខភាពបុរស/ជំងឺក្រពេញអ័រម៉ូន': 'MenSHealth/MenSHormoneIssues',
  'សុខភាពបុរស/បញ្ហាបុរសផ្សេងទៀត': 'MenSHealth/OtherMenSHealthIssues',
  'សុខភាពបុរស/សុខភាពលិង្គ': 'MenSHealth/PenisHealth',
  'សុខភាពបុរស/ជំងឺភេយរ៉ូនី': 'MenSHealth/PeyronieSDisease',
  សុខភាពបុរស: 'MenSHealth',
  'សុខភាពមាត់ធ្មេញ/សម្រស់មាត់ធ្មេញ': 'OralHealth/CosmeticDentistry',
  'សុខភាពមាត់ធ្មេញ/ជំងឺធ្មេញ': 'OralHealth/DentalConditions',
  'សុខភាពមាត់ធ្មេញ/ជំងឺអញ្ចាញនិងមាត់': 'OralHealth/GumAndMouthDiseases',
  'សុខភាពមាត់ធ្មេញ/ការថែទាំមាត់': 'OralHealth/OralCare',
  'សុខភាពមាត់ធ្មេញ/ការពត់ធ្មេញ': 'OralHealth/Orthodontics',
  'សុខភាពមាត់ធ្មេញ/បញ្ហាមាត់ធ្មេញផ្សេងទៀត': 'OralHealth/OtherOralHealthIssues',
  'សុខភាពមាត់ធ្មេញ/មាត់ធ្មេញកុមារ': 'OralHealth/PediatricDentistry',
  សុខភាពមាត់ធ្មេញ: 'OralHealth',
  'ជំងឺឆ្អឹងនិងសាច់ដុំ/ជំងឺរលាកសន្លាក់': 'Musculoskeletal/Arthritis',
  'ជំងឺឆ្អឹងនិងសាច់ដុំ/បាក់ឆ្អឹង': 'Musculoskeletal/FracturesAndBrokenBones',
  'ជំងឺឆ្អឹងនិងសាច់ដុំ/ឈឺឆ្អឹងនិងសាច់ដុំ':
    'Musculoskeletal/MusculoskeletalPain',
  'ជំងឺឆ្អឹងនិងសាច់ដុំ/វះកាត់ឆ្អឹង': 'Musculoskeletal/OrthopedicSurgery',
  'ជំងឺឆ្អឹងនិងសាច់ដុំ/ជំំងឺពុកឆ្អឹង': 'Musculoskeletal/Osteoporosis',
  'ជំងឺឆ្អឹងនិងសាច់ដុំ/ជំងឺឆ្អឹងផ្សេងទៀត': 'Musculoskeletal/OtherBoneDiseases',
  'ជំងឺឆ្អឹងនិងសាច់ដុំ/ជំងឺសន្លាក់និងសរសៃពួរ':
    'Musculoskeletal/OtherJointAndTendonDiseases',
  ជំងឺឆ្អឹងនិងសាច់ដុំ: 'Musculoskeletal',
  'ចិញ្ចឹមកូន/វ័យជំទង់': 'Parenting/Adolescents',
  'ចិញ្ចឹមកូន/វ័យជំទង់/ការលូតលាស់':
    'Parenting/Adolescents/MilestonesAndDevelopment',
  'ចិញ្ចឹមកូន/វ័យជំទង់/សុខភាពក្នុងវ័យជំទង់':
    'Parenting/Adolescents/AdolescenceHealth',
  'ចិញ្ចឹមកូន/វ័យជំទង់/សុខភាពផ្លូវចិត្ត-វ័យជំទង់':
    'Parenting/Adolescents/MentalHealth',
  'ចិញ្ចឹមកូន/ទារក/ទារកលូតលាស់ឆ្នាំដំបូង': 'Parenting/Baby/BabySFirstYear',
  'ចិញ្ចឹមកូន/ទារក': 'Parenting/Baby',
  'ចិញ្ចឹមកូន/ទារក/ការបំបៅដោះ': 'Parenting/Baby/Breastfeeding',
  'ចិញ្ចឹមកូន/ទារក/អាហារូបត្ថម្ភទារក': 'Parenting/Baby/BabyNutrition',
  'ចិញ្ចឹមកូន/ទារក/ការថែទាំទារក': 'Parenting/Baby/BabyCare',
  'ចិញ្ចឹមកូន/ទារក/ទារកមិនគ្រប់ខែ': 'Parenting/Baby/PrematureBabies',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ': 'Parenting/ChildHealth',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/ថ្នាំបង្ការ': 'Parenting/ChildHealth/Vaccines',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/រោគសញ្ញាទូទៅ':
    'Parenting/ChildHealth/CommonSymptomsAndConditions',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/ជំងឺឆ្លង-សុខភាពកុមារ':
    'Parenting/ChildHealth/InfectiousDiseasesInChildren',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/កង្វះអាហារូបត្ថម្ភ':
    'Parenting/ChildHealth/Malnutrition',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/បញ្ហាការលូតលាស់':
    'Parenting/ChildHealth/BehavioralAndDevelopmentalDisorders',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/ជំងឺប្រព័ន្ធប្រសាទ-សុខភាពកុមារ':
    'Parenting/ChildHealth/NeurologicalDiseases',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/បញ្ហាប្រព័ន្ធរំលាយអាហារ':
    'Parenting/ChildHealth/DigestiveProblems',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/ជំងឺស្បែក':
    'Parenting/ChildHealth/SkinDiseasesInChildren',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/ជំងឺផ្លូវដង្ហើម':
    'Parenting/ChildHealth/RespiratoryDiseases',
  'ចិញ្ចឹមកូន/សុខភាពកុមារ/បញ្ហាសុខភាពកុមារផ្សេងទៀត':
    'Parenting/ChildHealth/OtherChildHealthIssues',
  'ចិញ្ចឹមកូន/កុមារគ្រប់អាយុចូលរៀន': 'Parenting/SchoolAgeChildren',
  'ចិញ្ចឹមកូន/កុមារគ្រប់អាយុចូលរៀន/ដល់អាយុចូលរៀន':
    'Parenting/SchoolAgeChildren/SchoolAgeChildrenMilestones',
  'ចិញ្ចឹមកូន/កុមារគ្រប់អាយុចូលរៀន/ការលូតលាស់-កុមារគ្រប់អាយុចូលរៀន':
    'Parenting/SchoolAgeChildren/SchoolAgeChildrenGrowthAndDevelopment',
  'ចិញ្ចឹមកូន/កុមារគ្រប់អាយុចូលរៀន/អាហារូបត្ថម្ភ-កុមារគ្រប់អាយុចូលរៀន':
    'Parenting/SchoolAgeChildren/SchoolAgeChildrenNutrition',
  'ចិញ្ចឹមកូន/ការលូតលាស់-វ័យកូនចេះដើរនិងជិតចូលរៀន':
    'Parenting/ToddlerAndPreschoolerGrowthAndDevelopment',
  'ចិញ្ចឹមកូន/អាហារូបត្ថម្ភ-វ័យកូនចេះដើរនិងជិតចូលរៀន':
    'Parenting/ToddlerNutrition',
  'ចិញ្ចឹមកូន/វ័យកូនចេះដើរ': 'Parenting/ToddlerYears',
  ចិញ្ចឹមកូន: 'Parenting',
  'ពពោះ/មានផ្ទៃពោះ': 'Pregnancy/BeingPregnant',
  'ពពោះ/មានផ្ទៃពោះ/ត្រីមាសទី-1': 'Pregnancy/BeingPregnant/FirstTrimester',
  'ពពោះ/មានផ្ទៃពោះ/ត្រីមាសទី-2': 'Pregnancy/BeingPregnant/SecondTrimester',
  'ពពោះ/មានផ្ទៃពោះ/ត្រីមាសទី-3': 'Pregnancy/BeingPregnant/ThirdTrimester',
  'ពពោះ/មានផ្ទៃពោះ/បញ្ហាផ្ទៃពោះ': 'Pregnancy/BeingPregnant/PregnancyProblems',
  'ពពោះ/មានផ្ទៃពោះ/ការថែទាំផ្ទៃពោះមុនសម្រាល':
    'Pregnancy/BeingPregnant/PrenatalCare',
  'ពពោះ/មានផ្ទៃពោះ/បទពិសោធន៍មានផ្ទៃពោះ': 'Pregnancy/BeingPregnant/MyStory',
  'ពពោះ/សម្រាលកូន': 'Pregnancy/GivingBirth',
  'ពពោះ/សម្រាលកូន/ត្រៀមសម្រាល': 'Pregnancy/GivingBirth/Preparing',
  'ពពោះ/សម្រាលកូន/ថ្ងៃសម្រាល': 'Pregnancy/GivingBirth/LaborAndDelivery',
  'ពពោះ/សម្រាលកូន/ផលវិបាក-សម្រាលកូន': 'Pregnancy/GivingBirth/Complications',
  'ពពោះ/សម្រាលកូន/បទពិសោធន៍សម្រាលកូន': 'Pregnancy/GivingBirth/BirthStories',
  'ពពោះ/សុខភាពម្ដាយ': 'Pregnancy/Mothercare',
  'ពពោះ/សុខភាពម្ដាយ/ក្រោយសម្រាល': 'Pregnancy/Mothercare/PostpartumPeriod',
  'ពពោះ/សុខភាពម្ដាយ/ការថែទាំខ្លួនក្រោយសម្រាល':
    'Pregnancy/Mothercare/PostpartumSelfcare',
  'ពពោះ/សុខភាពម្ដាយ/សុខភាពផ្លូវចិត្ត-សុខភាពម្ដាយ':
    'Pregnancy/Mothercare/MentalHealth',
  'ពពោះ/សុខភាពម្ដាយ/បទពិសោធន៍អ្នកម្ដាយ': 'Pregnancy/Mothercare/WomanSVoice',
  'ពពោះ/សុខភាពម្ដាយ/បញ្ហាពីអ្នកម្ដាយផ្សេងទៀត':
    'Pregnancy/Mothercare/OtherMothercareTopics',
  'ពពោះ/បញ្ហាមុនមានផ្ទៃពោះផ្សេងទៀត': 'Pregnancy/OtherConceptionTopics',
  'ពពោះ/ការត្រៀមយកកូន': 'Pregnancy/GettingPregnant/PreparingToGetPregnant',
  'ពពោះ/ឧបសគ្គការមានកូននិងការព្យបាល':
    'Pregnancy/GettingPregnant/FertilityProblemsAndTreatment',
  'ពពោះ/មុនមានផ្ទៃពោះ/ឧបសគ្គការមានកូននិងការព្យបាល':
    'Pregnancy/GettingPregnant/FertilityProblemsAndTreatment',
  'ពពោះ/មុនមានផ្ទៃពោះ': 'Pregnancy/GettingPregnant',
  'ពពោះ/មុនមានផ្ទៃពោះ/ការត្រៀមយកកូន': 'Pregnancy/GettingPregnant/Adoption',
  'ពពោះ/មុនមានផ្ទៃពោះ/បញ្ហាមុនមានផ្ទៃពោះផ្សេងទៀត':
    'Pregnancy/GettingPregnant/OtherConceptionTopics',
  ពពោះ: 'Pregnancy',
  'សុខភាពផ្លូវដង្ហើម/ជំងឺហឺត': 'RespiratoryHealth/Asthma',
  'សុខភាពផ្លូវដង្ហើម/ស្វិតសួត': 'RespiratoryHealth/Bronchiectasis',
  'សុខភាពផ្លូវដង្ហើម/រលាកទងសួត': 'RespiratoryHealth/Bronchitis',
  'សុខភាពផ្លូវដង្ហើម/រលាកទងសួតរ៉ាំរ៉ៃ': 'RespiratoryHealth/ChronicBronchitis',
  'សុខភាពផ្លូវដង្ហើម/ផ្ដាសាយធម្មតា': 'RespiratoryHealth/CommonCold',
  'សុខភាពផ្លូវដង្ហើម/ហើមសួត': 'RespiratoryHealth/Emphysema',
  'សុខភាពផ្លូវដង្ហើម/ផ្ដាសាយធំ': 'RespiratoryHealth/Influenza',
  'សុខភាពផ្លូវដង្ហើម/ដុំពកសួតតូចៗ': 'RespiratoryHealth/LungGranulomas',
  'សុខភាពផ្លូវដង្ហើម/បញ្ហាសួតផ្សេងទៀត':
    'RespiratoryHealth/OtherRespiratoryIssues',
  'សុខភាពផ្លូវដង្ហើម/រលាកសួត': 'RespiratoryHealth/Pneumonia',
  'សុខភាពផ្លូវដង្ហើម/ស្ទះទងសួត': 'RespiratoryHealth/PulmonaryEmbolism',
  'សុខភាពផ្លូវដង្ហើម/ជំងឺរបេង': 'RespiratoryHealth/Tuberculosis',
  សុខភាពផ្លូវដង្ហើម: 'RespiratoryHealth',
  'សុខភាពផ្លូវភេទ/ប្រមេះទឹកបាយ': 'SexualWellness/Chlamydia',
  'សុខភាពផ្លូវភេទ/ការពន្យារកំណើត': 'SexualWellness/Contraception',
  'សុខភាពផ្លូវភេទ/រើមលើមាត់និងប្រដាប់ភេទ':
    'SexualWellness/GenitalAndOralHerpes',
  'សុខភាពផ្លូវភេទ/ប្រមេះទឹកថ្លា': 'SexualWellness/Gonorrhea',
  'សុខភាពផ្លូវភេទ/មេរោគហ៊ីវជំងឺអេដស៍': 'SexualWellness/HIVAIDS',
  'សុខភាពផ្លូវភេទ/ជំងឺបង្កដោយវីរុសអេចភីវី': 'SexualWellness/Hpv',
  'សុខភាពផ្លូវភេទ/ជំងឺកាមរោគ': 'SexualWellness/MoreStisAndStds',
  'សុខភាពផ្លូវភេទ/ផ្លូវភេទនិងការការពារ': 'SexualWellness/SafeSex',
  'សុខភាពផ្លូវភេទ/គន្លឹះសុខភាពផ្លូវភេទ': 'SexualWellness/SexTips',
  'សុខភាពផ្លូវភេទ/ជំងឺស្វាយ': 'SexualWellness/Syphilis',
  'សុខភាពផ្លូវភេទ/ទ្រីក្រូម៉ូណាស់': 'SexualWellness/Trichomoniasis',
  សុខភាពផ្លូវភេទ: 'SexualWellness',
  'សុខភាពស្បែក/ជំងឺមុន': 'SkinHealth/Acne',
  'សុខភាពស្បែក/បញ្ហារលាកស្បែក': 'SkinHealth/Dermatitis',
  'សុខភាពស្បែក/សក់និងស្បែកក្បាល': 'SkinHealth/HairAndScalpCare',
  'សុខភាពស្បែក/ជំងឺឆ្លងរោគលើស្បែក': 'SkinHealth/InfectiousSkinDiseases',
  'សុខភាពស្បែក/ក្រចក': 'SkinHealth/NailCare',
  'សុខភាពស្បែក/បញ្ហាស្បែកផ្សេងទៀត': 'SkinHealth/OtherSkinDiseases',
  'សុខភាពស្បែក/ជំងឺpsoriasis': 'SkinHealth/Psoriasis',
  'សុខភាពស្បែក/ស្បែក': 'SkinHealth/SkinCareAndCleansing',
  សុខភាពស្បែក: 'SkinHealth',
  'សុខភាពប្រព័ន្ធទឹកនោម/បញ្ហាប្លោកនោម': 'UrologicalHealth/BladderProblems',
  'សុខភាពប្រព័ន្ធទឹកនោម/ជំងឺតម្រងនោម': 'UrologicalHealth/KidneyDisease',
  'សុខភាពប្រព័ន្ធទឹកនោម/បញ្ហាប្រព័ន្ធទឹកនោមផ្សេងទៀត':
    'UrologicalHealth/OtherUrologicalIssues',
  'សុខភាពប្រព័ន្ធទឹកនោម/សុខភាពក្រពេញប្រូស្តាត':
    'UrologicalHealth/ProstateHealth',
  'សុខភាពប្រព័ន្ធទឹកនោម/លេចទឹកនោម': 'UrologicalHealth/UrinaryIncontinence',
  'សុខភាពប្រព័ន្ធទឹកនោម/ក្រួសក្នុងផ្លូវទឹកនោម':
    'UrologicalHealth/UrinaryTractStones',
  'សុខភាពប្រព័ន្ធទឹកនោម/ជំងឺប្រព័ន្ធផ្លូវទឹកនោម': 'UrologicalHealth/Uti',
  សុខភាពប្រព័ន្ធទឹកនោម: 'UrologicalHealth',
  'សុខភាពស្ត្រី/បម្រែបម្រួលអ័រម៉ូនស្ត្រី':
    'WomenSHealth/FemaleHormonalImbalance',
  'សុខភាពស្ត្រី/ការអស់រដូវ': 'WomenSHealth/Menopause',
  'សុខភាពស្ត្រី/ការមករដូវ': 'WomenSHealth/Menstruation',
  'សុខភាពស្ត្រី/ជំងឺដុំស្បូន': 'WomenSHealth/MyomaAndCysts',
  'សុខភាពស្ត្រី/ជំងឺគីសក្រពេញអូវែ': 'WomenSHealth/Pcos',
  'សុខភាពស្ត្រី/ការបង្ករោគអាងត្រគាក': 'WomenSHealth/PelvicRelatedIssue',
  'សុខភាពស្ត្រី/ការពិនិត្យនិងធ្វើតេស្ដសុខភាពស្ត្រី':
    'WomenSHealth/ScreeningAndTestsForWomen',
  'សុខភាពស្ត្រី/ទ្វារមាស': 'WomenSHealth/Vaginitis',
  'សុខភាពស្ត្រី/បញ្ហាស្ត្រីផ្សេងទៀត': 'WomenSHealth/WomenSHealthIssues',
  សុខភាពស្ត្រី: 'WomenSHealth',
}

export const hiIN: { [k: string]: string } = {
  dawaai: 'DrugsSupplements',
  'jadi-booti': 'HerbalsAlternatives',
  'jadi-booti/herbal-medicines': 'HerbalsAlternatives/HerbalMedicines',
  'jadi-booti/alternative-medicines':
    'HerbalsAlternatives/AlternativeMedicines',
  'aahar-aur-poshan': 'HealthyEating',
  'aahar-aur-poshan/diet-weight-management': 'HealthyEating/DietWeightLoss',
  'aahar-aur-poshan/healthy-recipe': 'HealthyEating/HealthyRecipes',
  'aahar-aur-poshan/motapa': 'HealthyEating/Obesity',
  'aahar-aur-poshan/nutrition-facts': 'HealthyEating/NutritionFacts',
  'aahar-aur-poshan/special-diets': 'HealthyEating/SpecialDiets',
  'aahar-aur-poshan/sports-nutrition': 'HealthyEating/SportsNutrition',
  'aahar-aur-poshan/other-healthy-eating-tips':
    'HealthyEating/OtherHealthyEatingTips',
  fitness: 'HealthFitness',
  'fitness/cardio-endurance': 'HealthFitness/CardioEndurance',
  'fitness/balance-flexibility': 'HealthFitness/BalanceFlexibility',
  'fitness/strength-training': 'HealthFitness/StrengthTraining',
  'fitness/fitness-motivation': 'HealthFitness/FitnessMotivation',
  'fitness/other-fitness-activities': 'HealthFitness/OtherFitnessActivities',
  'fitness/exercise-safety-tips': 'HealthFitness/ExerciseSafetyTips',
  'fitness/weight-loss-exercises': 'HealthFitness/WeightLossExercises',
  'maansik-swasthya': 'HealthyMind',
  'maansik-swasthya/addiction': 'HealthyMind/Addiction',
  'maansik-swasthya/anxiety-disorders': 'HealthyMind/AnxietyDisorders',
  'maansik-swasthya/mood-disorders': 'HealthyMind/MoodDisorders',
  'maansik-swasthya/suicide-prevention': 'HealthyMind/SuicidePrevention',
  'maansik-swasthya/stress-management': 'HealthyMind/StressManagement',
  'maansik-swasthya/eating-disorders': 'HealthyMind/EatingDisorders',
  'maansik-swasthya/healthy-relationships': 'HealthyMind/HealthyRelationships',
  'maansik-swasthya/developmental-disorders':
    'HealthyMind/DevelopmentalDisorder',
  'maansik-swasthya/mental-health-issues':
    'HealthyMind/OtherMentalHealthIssues',
  sleep: 'HealthySleep',
  'sleep/good-nights-sleep': 'HealthySleep/AGoodNightsSleep',
  'sleep/sleep-apnea': 'HealthySleep/SleepApnea',
  'sleep/insomnia': 'HealthySleep/Insomnia',
  'sleep/sleep-disorders': 'HealthySleep/SleepDisorders',
  'healthy-habits': 'HealthyHabits',
  'healthy-habits/quit-smoking': 'HealthyHabits/QuitSmoking',
  'healthy-habits/first-aid': 'HealthyHabits/FirstAid',
  'healthy-habits/general-hygiene': 'HealthyHabits/GeneralHygiene',
  'senior-health': 'HealthyAging',
  'senior-health/active-ageing': 'HealthyAging/ActiveAgeing',
  'senior-health/ageing-mind': 'HealthyAging/AgeingMind',
  'senior-health/ageing-body': 'HealthyAging/AgeingBody',
  'senior-health/nutrition-for-ageing': 'HealthyAging/NutritionforAgeing',
  'senior-health/common-ageing-conditions':
    'HealthyAging/CommonAgeingConditions',
  pregnancy: 'Pregnancy',
  'pregnancy/getting-pregnant': 'Pregnancy/GettingPregnant',
  'pregnancy/getting-pregnant/preparing-to-get-pregnant':
    'Pregnancy/GettingPregnant/PreparingToGetPregnant',
  'pregnancy/getting-pregnant/fertility-problems-and-treatment':
    'Pregnancy/GettingPregnant/FertilityProblemsTreatment',
  'pregnancy/getting-pregnant/real-stories':
    'Pregnancy/GettingPregnant/RealStories',
  'pregnancy/getting-pregnant/other-conception-topics':
    'Pregnancy/GettingPregnant/OtherConceptionTopics',
  'pregnancy/being-pregnant': 'Pregnancy/BeingPregnant',
  'pregnancy/being-pregnant/first-trimester':
    'Pregnancy/BeingPregnant/FirstTrimester',
  'pregnancy/being-pregnant/second-trimester':
    'Pregnancy/BeingPregnant/SecondTrimester',
  'pregnancy/being-pregnant/third-trimester':
    'Pregnancy/BeingPregnant/ThirdTrimester',
  'pregnancy/being-pregnant/pregnancy-problems':
    'Pregnancy/BeingPregnant/PregnancyProblems',
  'pregnancy/being-pregnant/prenatal-care':
    'Pregnancy/BeingPregnant/PrenatalCare',
  'pregnancy/being-pregnant/my-story': 'Pregnancy/BeingPregnant/MyStory',
  'pregnancy/giving-birth': 'Pregnancy/GivingBirth',
  'pregnancy/giving-birth/preparing': 'Pregnancy/GivingBirth/Preparing',
  'pregnancy/giving-birth/labor-and-delivery':
    'Pregnancy/GivingBirth/LaborDelivery',
  'pregnancy/giving-birth/complications': 'Pregnancy/GivingBirth/Complications',
  'pregnancy/giving-birth/birth-stories': 'Pregnancy/GivingBirth/BirthStories',
  'pregnancy/mothercare': 'Pregnancy/Mothercare',
  'pregnancy/mothercare/postpartum-period':
    'Pregnancy/Mothercare/PostpartumPeriod',
  'pregnancy/mothercare/postpartum-selfcare':
    'Pregnancy/Mothercare/PostpartumSelfcare',
  'pregnancy/mothercare/mental-health': 'Pregnancy/Mothercare/MentalHealth',
  'pregnancy/mothercare/womans-voice': 'Pregnancy/Mothercare/WomansVoice',
  'pregnancy/mothercare/other-mothercare-topics':
    'Pregnancy/Mothercare/OtherMothercareTopics',
  parenting: 'Parenting',
  'parenting/baby': 'Parenting/Baby',
  'parenting/baby/baby-first-year': 'Parenting/Baby/BabyFirstYear',
  'parenting/baby/breastfeeding': 'Parenting/Baby/Breastfeeding',
  'parenting/baby/baby-nutrition': 'Parenting/Baby/BabyNutrition',
  'parenting/baby/baby-care': 'Parenting/Baby/BabyCare',
  'parenting/baby/premature-babies': 'Parenting/Baby/Prematurebabies',
  'parenting/toddler-and-preschooler': 'Parenting/ToddlerPreschooler',
  'parenting/toddler-and-preschooler/toddler-and-preschooler-milestones':
    'Parenting/ToddlerPreschooler/ToddlerPreschoolerMilestones',
  'parenting/toddler-and-preschooler/toddler-and-preschooler-growth-and-development':
    'Parenting/ToddlerPreschooler/GrowthDevelopment',
  'parenting/toddler-and-preschooler/toddler-nutrition':
    'Parenting/ToddlerPreschooler/ToddlerNutrition',
  'parenting/school-age-children': 'Parenting/SchoolAgeChildren',
  'parenting/school-age-children/school-age-children-milestones':
    'Parenting/SchoolAgeChildren/SchoolAgeChildrenMilestones',
  'parenting/school-age-children/school-age-children-growth-and-development':
    'Parenting/SchoolAgeChildren/SchoolAgeChildrenGrowthDevelopment',
  'parenting/school-age-children/school-age-children-nutrition':
    'Parenting/SchoolAgeChildren/SchoolAgechildrenNutrition',
  'parenting/child-health': 'Parenting/ChildHealth',
  'parenting/child-health/vaccines': 'Parenting/ChildHealth/Vaccines',
  'parenting/child-health/common-symptoms-and-conditions':
    'Parenting/ChildHealth/CommonSymptomsConditions',
  'parenting/child-health/infectious-diseases-in-children':
    'Parenting/ChildHealth/InfectiousDiseasesinChildren',
  'parenting/child-health/malnutrition': 'Parenting/ChildHealth/Malnutrition',
  'parenting/child-health/behavioral-and-developmental-disorders':
    'Parenting/ChildHealth/BehavioralDevelopmentalDisorders',
  'parenting/child-health/neurological-diseases':
    'Parenting/ChildHealth/NeurologicalDiseases',
  'parenting/child-health/digestive-problems':
    'Parenting/ChildHealth/DigestiveProblems',
  'parenting/child-health/skin-diseases-in-children':
    'Parenting/ChildHealth/SkinDiseasesinChildren',
  'parenting/child-health/respiratory-diseases':
    'Parenting/ChildHealth/RespiratoryDiseases',
  'parenting/child-health/other-child-health-issues':
    'Parenting/ChildHealth/OtherChildHealthIssues',
  'parenting/adolescents': 'Parenting/Adolescents',
  'parenting/adolescents/milestones-and-development':
    'Parenting/Adolescents/MilestonesDevelopment',
  'parenting/adolescents/teen-mental-health':
    'Parenting/Adolescents/MentalHealth',
  'parenting/adolescents/adolescence-health':
    'Parenting/Adolescents/AdolescenceHealth',
  'heart-health': 'HeartHealth',
  'heart-health/hypertension': 'HeartHealth/Hypertension',
  'heart-health/hriday-rog': 'HeartHealth/HeartDisease',
  'heart-health/heart-infections': 'HeartHealth/HeartInfections',
  'heart-health/cholesterol': 'HeartHealth/Cholesterol',
  'heart-health/heart-failure': 'HeartHealth/HeartFailure',
  'heart-health/coronary-artery-disease': 'HeartHealth/CoronaryArteryDisease',
  'heart-health/heart-arrhythmias': 'HeartHealth/HeartArrhythmias',
  'heart-health/congenital-heart-disease': 'HeartHealth/CongenitalHeartDisease',
  'heart-health/heart-valve': 'HeartHealth/HeartValve',
  'heart-health/atherosclerosis': 'HeartHealth/Atherosclerosis',
  'heart-health/cardiomyopathy': 'HeartHealth/Cardiomyopathy',
  'heart-health/cardiovascular-issues': 'HeartHealth/OtherCardiovascularIssues',
  'khaasi-aur-sardi': 'RespiratoryHealth',
  'khaasi-aur-sardi/chronic-bronchitis': 'RespiratoryHealth/Chronicbronchitis',
  'khaasi-aur-sardi/emphysema': 'RespiratoryHealth/Emphysema',
  'khaasi-aur-sardi/bronchiectasis': 'RespiratoryHealth/Bronchiectasis',
  'khaasi-aur-sardi/asthma': 'RespiratoryHealth/Asthma',
  'khaasi-aur-sardi/influenza': 'RespiratoryHealth/Influenza',
  'khaasi-aur-sardi/tuberculosis': 'RespiratoryHealth/Tuberculosis',
  'khaasi-aur-sardi/pneumonia': 'RespiratoryHealth/Pneumonia',
  'khaasi-aur-sardi/lung-granulomas': 'RespiratoryHealth/Lunggranulomas',
  'khaasi-aur-sardi/common-cold': 'RespiratoryHealth/Commoncold',
  'khaasi-aur-sardi/bronchitis': 'RespiratoryHealth/Bronchitis',
  'khaasi-aur-sardi/pulmonary-embolism': 'RespiratoryHealth/PulmonaryEmbolism',
  'khaasi-aur-sardi/respiratory-issues':
    'RespiratoryHealth/OtherRespiratoryIssues',
  cancer: 'Cancer',
  'cancer/lung-cancer': 'Cancer/LungCancer',
  'cancer/colorectal-cancer': 'Cancer/ColorectalCancer',
  'cancer/stomach-cancer': 'Cancer/StomachCancer',
  'cancer/cervical-cancer': 'Cancer/CervicalCancer',
  'cancer/prostate-cancer': 'Cancer/ProstateCancer',
  'cancer/liver-cancer': 'Cancer/LiverCancer',
  'cancer/skin-cancer': 'Cancer/SkinCancer',
  'cancer/breast-cancer': 'Cancer/BreastCancer',
  'cancer/haddi-ka-cancer': 'Cancer/BoneCancer',
  'cancer/bladder-cancer': 'Cancer/BladderCancer',
  'cancer/thyroid-cancer': 'Cancer/ThyroidCancer',
  'cancer/ovarian-cancer': 'Cancer/OvarianCancer',
  'cancer/leukemia': 'Cancer/Leukemia',
  'cancer/pancreatic-cancer': 'Cancer/PancreaticCancer',
  'cancer/lymphoma': 'Cancer/Lymphoma',
  'cancer/brain-tumors': 'Cancer/BrainTumors',
  'cancer/head-neck-cancer': 'Cancer/HeadNeckCancer',
  'cancer/other-cancers': 'Cancer/OtherCancers',
  'mens-health': 'MensHealth',
  'mens-health/mens-hormone-issues': 'MensHealth/MensHormoneIssues',
  'mens-health/erectile-dysfunction': 'MensHealth/ErectileDysfunction',
  'mens-health/peyronies-disease': 'MensHealth/PeyroniesDisease',
  'mens-health/penis-health': 'MensHealth/PenisHealth',
  'mens-health/mens-health-issues': 'MensHealth/OtherMensHealthIssues',
  'womens-health': 'WomensHealth',
  'womens-health/pcos': 'WomensHealth/PCOS',
  'womens-health/uterine-fibroids': 'WomensHealth/UterineFibroids',
  'womens-health/vaginitis': 'WomensHealth/Vaginitis',
  'womens-health/pelvic-related-issue': 'WomensHealth/Pelvicrelatedissue',
  'womens-health/female-hormonal-imbalance':
    'WomensHealth/FemaleHormonalImbalance',
  'womens-health/menopause': 'WomensHealth/Menopause',
  'womens-health/screening-and-tests-for-women':
    'WomensHealth/ScreeningTestsforWomen',
  'womens-health/menstruation': 'WomensHealth/Menstruation',
  'womens-health/womens-health-issues': 'WomensHealth/WomensHealthIssues',
  'sex-aur-relationship': 'SexualWellness',
  'sex-aur-relationship/safe-sex': 'SexualWellness/SafeSex',
  'sex-aur-relationship/chlamydia': 'SexualWellness/Chlamydia',
  'sex-aur-relationship/syphilis': 'SexualWellness/Syphilis',
  'sex-aur-relationship/gonorrhea': 'SexualWellness/Gonorrhea',
  'sex-aur-relationship/genital-oral-herpes':
    'SexualWellness/GenitalOralHerpes',
  'sex-aur-relationship/hpv-infection': 'SexualWellness/HPV',
  'sex-aur-relationship/trichomoniasis': 'SexualWellness/Trichomoniasis',
  'sex-aur-relationship/hiv': 'SexualWellness/HIVAIDS',
  'sex-aur-relationship/std': 'SexualWellness/MoreSTIsSTDs',
  'sex-aur-relationship/contraception': 'SexualWellness/Contraception',
  'sex-aur-relationship/sex-tips': 'SexualWellness/SexTips',
  'neurological-bimari': 'BrainNervousSystem',
  'neurological-bimari/seizure-disorders':
    'BrainNervousSystem/SeizureDisorders',
  'neurological-bimari/dementia-alzheimers-disease':
    'BrainNervousSystem/DementiaAlzheimersDisease',
  'neurological-bimari/multiple-sclerosis':
    'BrainNervousSystem/MultipleSclerosis',
  'neurological-bimari/parkinsons-disease':
    'BrainNervousSystem/ParkinsonsDisease',
  'neurological-bimari/stroke-aneurysm': 'BrainNervousSystem/StrokeAneurysm',
  'neurological-bimari/headaches-migraines':
    'BrainNervousSystem/HeadachesMigraines',
  'neurological-bimari/brain-spine-disorders':
    'BrainNervousSystem/BrainSpineDisorders',
  'neurological-bimari/peripheral-nervous-system-disorders':
    'BrainNervousSystem/PeripheralNervousSystemDisorders',
  'neurological-bimari/brain-nervous-system-issues':
    'BrainNervousSystem/OtherBrainNSIssues',
  'allergies-aur-autoimmune-conditions': 'Allergies',
  'allergies-aur-autoimmune-conditions/food-allergies':
    'Allergies/FoodAllergies',
  'allergies-aur-autoimmune-conditions/nose-eye-allergies': 'Allergies/NoseEye',
  'allergies-aur-autoimmune-conditions/skin-allergies':
    'Allergies/SkinAllergies',
  'allergies-aur-autoimmune-conditions/animal-insects-allergies':
    'Allergies/AnimalInsect',
  'allergies-aur-autoimmune-conditions/other-allergies':
    'Allergies/OtherAllergies',
  'infectious-diseases': 'InfectiousDiseases',
  'infectious-diseases/coronavirus': 'InfectiousDiseases/Coronavirus',
  'infectious-diseases/respiratory-infections':
    'InfectiousDiseases/RespiratoryInfections',
  'infectious-diseases/foodborne-infections':
    'InfectiousDiseases/FoodborneInfections',
  'infectious-diseases/other-bacterial-infections':
    'InfectiousDiseases/Otherbacterialinfections',
  'infectious-diseases/airborne-infections':
    'InfectiousDiseases/AirborneInfections',
  'infectious-diseases/zika': 'InfectiousDiseases/Zika',
  'infectious-diseases/dengue': 'InfectiousDiseases/Dengue',
  'infectious-diseases/infections-from-insects':
    'InfectiousDiseases/InfectionsfromInsects',
  'infectious-diseases/other-viral-infections':
    'InfectiousDiseases/Otherviralinfections',
  'infectious-diseases/meningitis': 'InfectiousDiseases/Meningitis',
  'infectious-diseases/herpes': 'InfectiousDiseases/Herpes',
  'infectious-diseases/typhoid-fever': 'InfectiousDiseases/TyphoidFever',
  'pet-sambhandit-bimari': 'DigestiveHealth',
  'pet-sambhandit-bimari/stomach-ulcer': 'DigestiveHealth/StomachUlcer',
  'pet-sambhandit-bimari/bloating-and-gas': 'DigestiveHealth/BloatingGas',
  'pet-sambhandit-bimari/kabj': 'DigestiveHealth/Constipation',
  'pet-sambhandit-bimari/dast': 'DigestiveHealth/Diarrhea',
  'pet-sambhandit-bimari/ibd': 'DigestiveHealth/InflammatroyBowelDisease',
  'pet-sambhandit-bimari/irritable-bowel-syndrome':
    'DigestiveHealth/IrritableBowelSyndrome',
  'pet-sambhandit-bimari/heartburn': 'DigestiveHealth/Heartburn',
  'pet-sambhandit-bimari/gerd': 'DigestiveHealth/GERD',
  'pet-sambhandit-bimari/peptic-ulcer-disease':
    'DigestiveHealth/PepticUlcerDisease',
  'pet-sambhandit-bimari/pet-mein-soojan': 'DigestiveHealth/Gastritis',
  'pet-sambhandit-bimari/stomach-flu': 'DigestiveHealth/StomachFlu',
  'pet-sambhandit-bimari/sibo': 'DigestiveHealth/SIBO',
  'pet-sambhandit-bimari/gallbladder-disease':
    'DigestiveHealth/GallbladderDisease',
  'pet-sambhandit-bimari/hemorrhoids': 'DigestiveHealth/Hemorrhoids',
  'pet-sambhandit-bimari/gastroenteritis': 'DigestiveHealth/Gastroenteritis',
  'pet-sambhandit-bimari/other-digestive-health-issues':
    'DigestiveHealth/OtherDigestiveHealthIssues',
  'digestive-health/liver-diseases': 'DigestiveHealth/LiverDiseases',
  'musculoskeletal-bimari': 'Musculoskeletal',
  'musculoskeletal-bimari/osteoperosis': 'Musculoskeletal/Osteoporosis',
  'musculoskeletal-bimari/arthritis': 'Musculoskeletal/Arthritis',
  'musculoskeletal-bimari/orthopedic-surgery':
    'Musculoskeletal/OrthopedicSurgery',
  'musculoskeletal-bimari/fractures-and-broken-bones':
    'Musculoskeletal/FracturesBrokenBones',
  'musculoskeletal-bimari/musculoskeletal-pain':
    'Musculoskeletal/MusculoskeletalPain',
  'musculoskeletal-bimari/other-joint-and-tendon-diseases':
    'Musculoskeletal/OtherJointTendonDiseases',
  'musculoskeletal-bimari/other-bone-diseases':
    'Musculoskeletal/Otherbonediseases',
  'kidney-aur-urinary-tract-bimari': 'UrologicalHealth',
  'kidney-aur-urinary-tract-bimari/kidney-disease':
    'UrologicalHealth/KidneyDisease',
  'kidney-aur-urinary-tract-bimari/bladder-problems':
    'UrologicalHealth/BladderProblems',
  'kidney-aur-urinary-tract-bimari/urinary-tract-stones':
    'UrologicalHealth/UrinaryTractStones',
  'kidney-aur-urinary-tract-bimari/urinary-incontinence':
    'UrologicalHealth/UrinaryIncontinence',
  'kidney-aur-urinary-tract-bimari/other-urological-issues':
    'UrologicalHealth/OtherUrologicalIssues',
  'kidney-aur-urinary-tract-bimari/prostate-health':
    'UrologicalHealth/ProstateHealth',
  'kidney-aur-urinary-tract-bimari/uti': 'UrologicalHealth/UTI',
  'eye-health': 'EyeHealth',
  'eye-health/vision-impairment-loss': 'EyeHealth/VisionImpairmentLoss',
  'eye-health/eye-diseases': 'EyeHealth/EyeDiseases',
  'eye-health/eye-care': 'EyeHealth/Eyecare',
  'eye-health/glaucoma': 'EyeHealth/Glaucoma',
  'eye-health/cataracts': 'EyeHealth/Cataracts',
  'eye-health/other-eye-issues': 'EyeHealth/OtherEyeIssues',
  'oral-swasthya': 'OralHealth',
  'oral-swasthya/gum-and-mouth-diseases': 'OralHealth/GumMouthDiseases',
  'oral-swasthya/dental-conditions': 'OralHealth/DentalConditions',
  'oral-swasthya/oral-care': 'OralHealth/Oralcare',
  'oral-swasthya/cosmetic-dentistry': 'OralHealth/CosmeticDentistry',
  'oral-swasthya/orthodontics': 'OralHealth/Orthodontics',
  'oral-swasthya/pediatric-dentistry': 'OralHealth/PediatricDentistry',
  'oral-swasthya/other-oral-health-issues': 'OralHealth/OtherOralHealthIssues',
  'skin-health': 'SkinHealth',
  'skin-health/nail-care': 'SkinHealth/Nailcare',
  'skin-health/hair-care-aur-hair-loss': 'SkinHealth/HairScalpCare',
  'skin-health/skin-care-and-cleansing': 'SkinHealth/SkinCareCleansing',
  'skin-health/infectious-skin-diseases': 'SkinHealth/InfectiousSkinDiseases',
  'skin-health/muhaase': 'SkinHealth/Acne',
  'skin-health/psoriasis': 'SkinHealth/Psoriasis',
  'skin-health/dermatitis': 'SkinHealth/Dermatitis',
  'skin-health/other-skin-diseases': 'SkinHealth/OtherSkinDiseases',
  diabetes: 'Diabetes',
  'diabetes/type1-diabetes': 'Diabetes/Type1Diabetes',
  'diabetes/type2-diabetes': 'Diabetes/Type2Diabetes',
  'diabetes/diabetes-complications': 'Diabetes/DiabetesComplications',
  'blood-disorders': 'BloodDisorders',
  'blood-disorders/khoon-ki-kami': 'BloodDisorders/Anemia',
  'blood-disorders/thalassemia': 'BloodDisorders/Thalassemia',
  'blood-disorders/haemophilia': 'BloodDisorders/Hemophilia',
  'blood-disorders/platelet-disorder': 'BloodDisorders/Plateletdisorder',
  'blood-disorders/white-bloodcell-disorder':
    'BloodDisorders/WhiteBloodCelldisorder',
  'blood-disorders/other-blood-disorders': 'BloodDisorders/OtherBloodDisorders',
  'kaan-naak-gale-ki-bimari': 'ENT',
  'kaan-naak-gale-ki-bimari/ear-conditions': 'ENT/EarConditions',
  'kaan-naak-gale-ki-bimari/nose-conditions': 'ENT/NoseConditions',
  'kaan-naak-gale-ki-bimari/throat-conditions': 'ENT/ThroatConditions',
  health: 'Health',
  'health/bima': 'Health/HealthInsurance',
  'health/health-news': 'Health/Healthnews',
  'health/symptoms': 'Health/Symptoms',
  'health/general-health-knowledge': 'Health/GeneralHealthKnowledge',
  'health/hospital-and-doctor-reviews': 'Health/HospitalDoctorReviews',
  'health/medical-test': 'Health/MedicalTests',
  'health/surgery': 'Health/MedicalProceduresSurgeries',
}

export const th: { [k: string]: string } = {
  ยาและอาหารเสริม: 'DrugsSupplements',
  สมุนไพรและการแพทย์ทางเลือก: 'HerbalsAlternatives',
  'สมุนไพรและการแพทย์ทางเลือก/ยาสมุนไพร': 'HerbalsAlternatives/HerbalMedicines',
  'สมุนไพรและการแพทย์ทางเลือก/การแพทย์ทางเลือก':
    'HerbalsAlternatives/AlternativeMedicines',
  โภชนาการเพื่อสุขภาพ: 'HealthyEating',
  'โภชนาการเพื่อสุขภาพ/การควบคุมอาหารและการลดน้ำหนัก':
    'HealthyEating/DietWeightLoss',
  'โภชนาการเพื่อสุขภาพ/สูตรอาหารเพื่อสุขภาพ': 'HealthyEating/HealthyRecipes',
  'โภชนาการเพื่อสุขภาพ/โรคอ้วน': 'HealthyEating/Obesity',
  'โภชนาการเพื่อสุขภาพ/ข้อมูลโภชนาการ': 'HealthyEating/NutritionFacts',
  'โภชนาการเพื่อสุขภาพ/โภชนาการพิเศษ': 'HealthyEating/SpecialDiets',
  'โภชนาการเพื่อสุขภาพ/โภชนาการการกีฬา': 'HealthyEating/SportsNutrition',
  'โภชนาการเพื่อสุขภาพ/เคล็ดลับโภชนาการที่ดี':
    'HealthyEating/OtherHealthyEatingTips',
  การออกกำลังกาย: 'HealthFitness',
  'การออกกำลังกาย/คาร์ดิโอและความทนทาน': 'HealthFitness/CardioEndurance',
  'การออกกำลังกาย/การทรงตัวและความยืดหยุ่น': 'HealthFitness/BalanceFlexibility',
  'การออกกำลังกาย/การฝึกความแข็งแรง': 'HealthFitness/StrengthTraining',
  'การออกกำลังกาย/มาออกกำลังกายกันเถอะ': 'HealthFitness/FitnessMotivation',
  'การออกกำลังกาย/กิจกรรมออกกำลังกายแบบอื่น':
    'HealthFitness/OtherFitnessActivities',
  'การออกกำลังกาย/เคล็ดลับการออกกำลังกายอย่างปลอดภัย':
    'HealthFitness/ExerciseSafetyTips',
  'การออกกำลังกาย/การออกกำลังกายเพื่อลดน้ำหนัก':
    'HealthFitness/WeightLossExercises',
  สุขภาพจิต: 'HealthyMind',
  'สุขภาพจิต/การเสพติด': 'HealthyMind/Addiction',
  'สุขภาพจิต/โรควิตกกังวล': 'HealthyMind/AnxietyDisorders',
  'สุขภาพจิต/ความผิดปกติทางอารมณ์': 'HealthyMind/MoodDisorders',
  'สุขภาพจิต/การป้องกันการฆ่าตัวตาย': 'HealthyMind/SuicidePrevention',
  'สุขภาพจิต/การจัดการความเครียด': 'HealthyMind/StressManagement',
  'สุขภาพจิต/โรคการกินผิดปกติ': 'HealthyMind/EatingDisorders',
  'สุขภาพจิต/ความสัมพันธ์ที่ดี': 'HealthyMind/HealthyRelationships',
  'สุขภาพจิต/ความผิดปกติด้านพัฒนาการ': 'HealthyMind/DevelopmentalDisorder',
  'สุขภาพจิต/ปัญหาสุขภาพจิตแบบอื่น': 'HealthyMind/OtherMentalHealthIssues',
  'หลับดี-สุขภาพดี': 'HealthySleep',
  'หลับดี-สุขภาพดี/เคล็ดลับในการนอนหลับ': 'HealthySleep/AGoodNightSSleep',
  'หลับดี-สุขภาพดี/ภาวะหยุดหายใจขณะนอนหลับ': 'HealthySleep/SleepApnea',
  'หลับดี-สุขภาพดี/โรคนอนไม่หลับ': 'HealthySleep/Insomnia',
  'หลับดี-สุขภาพดี/ความผิดปกติด้านการนอน': 'HealthySleep/SleepDisorders',
  พฤติกรรมสร้างเสริมสุขภาพ: 'HealthyHabits',
  'พฤติกรรมสร้างเสริมสุขภาพ/การเลิกบุหรี่-พฤติกรรมสร้างเสริมสุขภาพ':
    'HealthyHabits/QuitSmoking',
  'พฤติกรรมสร้างเสริมสุขภาพ/การปฐมพยาบาล-พฤติกรรมสร้างเสริมสุขภาพ':
    'HealthyHabits/FirstAid',
  'พฤติกรรมสร้างเสริมสุขภาพ/การดูแลสุขอนามัย': 'HealthyHabits/GeneralHygiene',
  สูงวัยอย่างมีคุณภาพ: 'HealthyAging',
  'สูงวัยอย่างมีคุณภาพ/สูงวัยอย่างมีพลัง': 'HealthyAging/ActiveAgeing',
  'สูงวัยอย่างมีคุณภาพ/สุขภาพจิตผู้สูงวัย': 'HealthyAging/AgeingMind',
  'สูงวัยอย่างมีคุณภาพ/สุขภาพกายผู้สูงวัย': 'HealthyAging/AgeingBody',
  'สูงวัยอย่างมีคุณภาพ/โภชนาการผู้สูงวัย': 'HealthyAging/NutritionForAgeing',
  'สูงวัยอย่างมีคุณภาพ/ปัญหาสุขภาพผู้สูงอายุ':
    'HealthyAging/CommonAgeingConditions',
  การตั้งครรภ์: 'Pregnancy',
  'การตั้งครรภ์/เตรียมตั้งครรภ์': 'Pregnancy/GettingPregnant',
  'การตั้งครรภ์/เตรียมตั้งครรภ์/เตรียมพร้อมก่อนตั้งครรภ์':
    'Pregnancy/GettingPregnant/PreparingToGetPregnant',
  'การตั้งครรภ์/เตรียมตั้งครรภ์/ปัญหามีบุตรยากและการรักษา':
    'Pregnancy/GettingPregnant/FertilityProblemsTreatment',
  'การตั้งครรภ์/เตรียมตั้งครรภ์/เรื่องจริงจากผู้เตรียมตัวเป็นคุณแม่':
    'Pregnancy/GettingPregnant/RealStories',
  'การตั้งครรภ์/เตรียมตั้งครรภ์/หัวข้ออื่นเกี่ยวกับการเตรียมตั้งครรภ์':
    'Pregnancy/GettingPregnant/OtherConceptionTopics',
  'การตั้งครรภ์/ระหว่างตั้งครรภ์': 'Pregnancy/BeingPregnant',
  'การตั้งครรภ์/ระหว่างตั้งครรภ์/ไตรมาสที่-1':
    'Pregnancy/BeingPregnant/FirstTrimester',
  'การตั้งครรภ์/ระหว่างตั้งครรภ์/ไตรมาสที่-2-ระหว่างตั้งครรภ์':
    'Pregnancy/BeingPregnant/SecondTrimester',
  'การตั้งครรภ์/ระหว่างตั้งครรภ์/ไตรมาสที่-3-ระหว่างตั้งครรภ์':
    'Pregnancy/BeingPregnant/ThirdTrimester',
  'การตั้งครรภ์/ระหว่างตั้งครรภ์/ปัญหาระหว่างการตั้งครรภ์':
    'Pregnancy/BeingPregnant/PregnancyProblems',
  'การตั้งครรภ์/ระหว่างตั้งครรภ์/การดูแลก่อนคลอด':
    'Pregnancy/BeingPregnant/PrenatalCare',
  'การตั้งครรภ์/ระหว่างตั้งครรภ์/เรื่องเล่าจากคุณแม่':
    'Pregnancy/BeingPregnant/MyStory',
  'การตั้งครรภ์/การคลอดและหลังคลอด': 'Pregnancy/GivingBirth',
  'การตั้งครรภ์/การคลอดและหลังคลอด/เตรียมตัวก่อนคลอด':
    'Pregnancy/GivingBirth/Preparing',
  'การตั้งครรภ์/การคลอดและหลังคลอด/การคลอด':
    'Pregnancy/GivingBirth/LaborDelivery',
  'การตั้งครรภ์/การคลอดและหลังคลอด/ภาวะแทรกซ้อนจากการคลอด':
    'Pregnancy/GivingBirth/Complications',
  'การตั้งครรภ์/การคลอดและหลังคลอด/เรื่องเล่าจากห้องคลอด':
    'Pregnancy/GivingBirth/BirthStories',
  'การตั้งครรภ์/สุขภาพคุณแม่': 'Pregnancy/Mothercare',
  'การตั้งครรภ์/สุขภาพคุณแม่/ช่วงเวลาหลังคลอด':
    'Pregnancy/Mothercare/PostpartumPeriod',
  'การตั้งครรภ์/สุขภาพคุณแม่/การดูแลตัวเองหลังคลอด':
    'Pregnancy/Mothercare/PostpartumSelfcare',
  'การตั้งครรภ์/สุขภาพคุณแม่/สุขภาพจิตคุณแม่':
    'Pregnancy/Mothercare/MentalHealth',
  'การตั้งครรภ์/สุขภาพคุณแม่/เสียงจากคุณแม่':
    'Pregnancy/Mothercare/WomanSVoice',
  'การตั้งครรภ์/สุขภาพคุณแม่/เคล็ดลับดูแลคุณแม่':
    'Pregnancy/Mothercare/OtherMothercareTopics',
  พ่อแม่เลี้ยงลูก: 'Parenting',
  'พ่อแม่เลี้ยงลูก/เด็กทารก': 'Parenting/Baby',
  'พ่อแม่เลี้ยงลูก/เด็กทารก/ขวบปีแรกของลูกน้อย': 'Parenting/Baby/BabyFirstYear',
  'พ่อแม่เลี้ยงลูก/เด็กทารก/เลี้ยงลูกด้วยนมแม่': 'Parenting/Baby/Breastfeeding',
  'พ่อแม่เลี้ยงลูก/เด็กทารก/โภชนาการสำหรับทารก': 'Parenting/Baby/BabyNutrition',
  'พ่อแม่เลี้ยงลูก/เด็กทารก/การดูแลทารก': 'Parenting/Baby/BabyCare',
  'พ่อแม่เลี้ยงลูก/เด็กทารก/ทารกคลอดก่อนกำหนด':
    'Parenting/Baby/PrematureBabies',
  'พ่อแม่เลี้ยงลูก/เด็กวัยหัดเดินและเด็กก่อนวัยเรียน':
    'Parenting/ToddlerPreschooler',
  'พ่อแม่เลี้ยงลูก/เด็กวัยหัดเดินและเด็กก่อนวัยเรียน/ลูกวัยเตาะแตะและเด็กก่อนวัยเรียน':
    'Parenting/ToddlerPreschooler/ToddlerPreschoolerMilestones',
  'พ่อแม่เลี้ยงลูก/เด็กวัยหัดเดินและเด็กก่อนวัยเรียน/การเติบโตและพัฒนาการ':
    'Parenting/ToddlerPreschooler/GrowthDevelopment',
  'พ่อแม่เลี้ยงลูก/เด็กวัยหัดเดินและเด็กก่อนวัยเรียน/การดูแลเด็กวัยหัดเดินและเด็กก่อนวัยเรียน':
    'Parenting/ToddlerPreschooler/ToddlerNutrition',
  'พ่อแม่เลี้ยงลูก/เด็กวัยเรียน': 'Parenting/SchoolAgeChildren',
  'พ่อแม่เลี้ยงลูก/เด็กในวัยเรียน/ช่วงวัยเรียน':
    'Parenting/SchoolAgeChildren/SchoolAgeChildrenMilestones',
  'พ่อแม่เลี้ยงลูก/เด็กวัยเรียน/การเติบโตและพัฒนาการในวัยเรียน':
    'Parenting/SchoolAgeChildren/SchoolAgeChildrenGrowthDevelopment',
  'พ่อแม่เลี้ยงลูก/เด็กวัยเรียน/การดูแลเด็กวัยเรียน':
    'Parenting/SchoolAgeChildren/SchoolAgeChildrenNutrition',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก': 'Parenting/ChildHealth',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/วัคซีน': 'Parenting/ChildHealth/Vaccines',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/โรคเด็กและอาการทั่วไป':
    'Parenting/ChildHealth/CommonSymptomsConditions',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/โรคติดเชื้อในเด็ก':
    'Parenting/ChildHealth/InfectiousDiseasesInChildren',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/ภาวะทุพโภชนาการ':
    'Parenting/ChildHealth/Malnutrition',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/ความผิดปกติทางพัฒนาการและพฤติกรรม':
    'Parenting/ChildHealth/BehavioralDevelopmentalDisorders',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/โรคระบบประสาทในเด็ก':
    'Parenting/ChildHealth/NeurologicalDiseases',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/ปัญหาระบบย่อยอาหารในเด็ก':
    'Parenting/ChildHealth/DigestiveProblems',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/โรคผิวหนังในเด็ก':
    'Parenting/ChildHealth/SkinDiseasesInChildren',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/โรคทางเดินหายใจในเด็ก':
    'Parenting/ChildHealth/RespiratoryDiseases',
  'พ่อแม่เลี้ยงลูก/สุขภาพเด็ก/ปัญหาสุขภาพเด็กแบบอื่น':
    'Parenting/ChildHealth/OtherChildHealthIssues',
  'พ่อแม่เลี้ยงลูก/วัยรุ่น': 'Parenting/Adolescents',
  'พ่อแม่เลี้ยงลูก/วัยรุ่น/ช่วงเวลาสำคัญและพัฒนาการวัยรุ่น':
    'Parenting/Adolescents/MilestonesDevelopment',
  'พ่อแม่เลี้ยงลูก/วัยรุ่น/สุขภาพจิตวัยรุ่น':
    'Parenting/Adolescents/MentalHealth',
  'พ่อแม่เลี้ยงลูก/สุขภาพวัยรุ่น': 'Parenting/Adolescents/AdolescenceHealth',
  สุขภาพหัวใจ: 'HeartHealth',
  'สุขภาพหัวใจ/โรคความดันโลหิตสูง': 'HeartHealth/Hypertension',
  'สุขภาพหัวใจ/โรคหัวใจ': 'HeartHealth/HeartDisease',
  'สุขภาพหัวใจ/โรคหัวใจ/การติดเชื้อที่หัวใจ': 'HeartHealth/HeartInfections',
  'สุขภาพหัวใจ/คอเลสเตอรอล': 'HeartHealth/Cholesterol',
  'สุขภาพหัวใจ/ภาวะหัวใจล้มเหลว': 'HeartHealth/HeartFailure',
  'สุขภาพหัวใจ/โรคหลอดเลือดหัวใจ': 'HeartHealth/CoronaryArteryDisease',
  'สุขภาพหัวใจ/ภาวะหัวใจเต้นผิดปกติ': 'HeartHealth/HeartArrhythmias',
  'สุขภาพหัวใจ/โรคหัวใจผิดปกติแต่กำเนิด': 'HeartHealth/CongenitalHeartDisease',
  'สุขภาพหัวใจ/โรคลิ้นหัวใจ': 'HeartHealth/HeartValve',
  'สุขภาพหัวใจ/ภาวะหลอดเลือดแข็ง': 'HeartHealth/Atherosclerosis',
  'สุขภาพหัวใจ/โรคกล้ามเนื้อหัวใจเสื่อม': 'HeartHealth/Cardiomyopathy',
  'สุขภาพหัวใจ/ปัญหาอื่นของโรคหัวใจและหลอดเลือด':
    'HeartHealth/OtherCardiovascularIssues',
  โรคทางเดินหายใจ: 'RespiratoryHealth',
  'โรคทางเดินหายใจ/โรคหลอดลมอักเสบเรื้อรัง':
    'RespiratoryHealth/ChronicBronchitis',
  'โรคทางเดินหายใจ/โรคถุงลมโป่งพอง': 'RespiratoryHealth/Emphysema',
  'โรคทางเดินหายใจ/โรคหลอดลมโป่งพอง': 'RespiratoryHealth/Bronchiectasis',
  'โรคทางเดินหายใจ/โรคหอบหืด': 'RespiratoryHealth/Asthma',
  'โรคทางเดินหายใจ/ไข้หวัดใหญ่': 'RespiratoryHealth/Influenza',
  'โรคทางเดินหายใจ/วัณโรค': 'RespiratoryHealth/Tuberculosis',
  'โรคทางเดินหายใจ/โรคปอดบวม': 'RespiratoryHealth/Pneumonia',
  'โรคทางเดินหายใจ/โรคปอดอักเสบแบบแกรนูโลมา':
    'RespiratoryHealth/LungGranulomas',
  'โรคทางเดินหายใจ/ไข้หวัด': 'RespiratoryHealth/CommonCold',
  'โรคทางเดินหายใจ/โรคหลอดลมอักเสบ': 'RespiratoryHealth/Bronchitis',
  'โรคทางเดินหายใจ/โรคลิ่มเลือดอุดกั้นในปอด':
    'RespiratoryHealth/PulmonaryEmbolism',
  'โรคทางเดินหายใจ/ปัญหาระบบทางเดินหายใจแบบอื่น':
    'RespiratoryHealth/OtherRespiratoryIssues',
  โรคมะเร็ง: 'Cancer',
  'โรคมะเร็ง/มะเร็งปอด': 'Cancer/LungCancer',
  'โรคมะเร็ง/มะเร็งลำไส้ใหญ่-โรคมะเร็ง': 'Cancer/ColorectalCancer',
  'โรคมะเร็ง/มะเร็งกระเพาะอาหาร': 'Cancer/StomachCancer',
  'โรคมะเร็ง/มะเร็งปากมดลูก-โรคมะเร็ง': 'Cancer/CervicalCancer',
  'โรคมะเร็ง/มะเร็งต่อมลูกหมาก-โรคมะเร็ง': 'Cancer/ProstateCancer',
  'โรคมะเร็ง/มะเร็งตับ-โรคมะเร็ง': 'Cancer/LiverCancer',
  'โรคมะเร็ง/มะเร็งผิวหนัง-โรคมะเร็ง': 'Cancer/SkinCancer',
  'โรคมะเร็ง/มะเร็งเต้านม': 'Cancer/BreastCancer',
  'โรคมะเร็ง/มะเร็งกระดูก': 'Cancer/BoneCancer',
  'โรคมะเร็ง/มะเร็งกระเพาะปัสสาวะ': 'Cancer/BladderCancer',
  'โรคมะเร็ง/มะเร็งต่อมไทรอยด์': 'Cancer/ThyroidCancer',
  'โรคมะเร็ง/มะเร็งรังไข่': 'Cancer/OvarianCancer',
  'โรคมะเร็ง/มะเร็งเม็ดเลือดขาว': 'Cancer/Leukemia',
  'โรคมะเร็ง/มะเร็งตับอ่อน': 'Cancer/PancreaticCancer',
  'โรคมะเร็ง/มะเร็งต่อมน้ำเหลือง': 'Cancer/Lymphoma',
  'โรคมะเร็ง/เนื้องอกในสมอง': 'Cancer/BrainTumors',
  'โรคมะเร็ง/มะเร็งศีรษะและคอ': 'Cancer/HeadNeckCancer',
  'โรคมะเร็ง/มะเร็งแบบอื่น': 'Cancer/OtherCancers',
  สุขภาพชาย: 'MenSHealth',
  'สุขภาพชาย/ปัญหาฮอร์โมนในเพศชาย': 'MenSHealth/MenSHormoneIssues',
  'สุขภาพชาย/ภาวะเสื่อมสมรรถภาพทางเพศ': 'MenSHealth/ErectileDysfunction',
  'สุขภาพชาย/โรคอวัยวะเพศชายโค้งงอ': 'MenSHealth/PeyronieSDisease',
  'สุขภาพชาย/สุุขภาพอวัยวะเพศชาย': 'MenSHealth/PenisHealth',
  'สุขภาพชาย/ปัญหาสุขภาพชายแบบอื่น': 'MenSHealth/OtherMenSHealthIssues',
  สุขภาพหญิง: 'WomenSHealth',
  'สุขภาพหญิง/ภาวะถุงน้ำรังไข่หลายใบ': 'WomenSHealth/PCOS',
  'สุขภาพหญิง/เนื้องอกในมดลูก-สุขภาพหญิง': 'WomenSHealth/UterineFibroids',
  'สุขภาพหญิง/ภาวะฮอร์โมนไม่สมดุลในเพศหญิง': 'WomenSHealth/Vaginitis',
  'สุขภาพหญิง/ภาวะช่องคลอดอักเสบ': 'WomenSHealth/PelvicRelatedIssue',
  'สุขภาพหญิง/ปัญหาเกี่ยวกับกระดูกเชิงกราน':
    'WomenSHealth/FemaleHormonalImbalance',
  'สุขภาพหญิง/วัยหมดประจำเดือน': 'WomenSHealth/Menopause',
  'สุขภาพหญิง/การตรวจคัดกรองโรคในผู้หญิง':
    'WomenSHealth/ScreeningTestsForWomen',
  'สุขภาพหญิง/การมีประจำเดือน': 'WomenSHealth/Menstruation',
  'สุขภาพหญิง/ปัญหาสุขภาพหญิงแบบอื่น': 'WomenSHealth/WomenSHealthIssues',
  สุขภาพทางเพศ: 'SexualWellness',
  'สุขภาพทางเพศ/การมีเพศสัมพันธ์อย่างปลอดภัย': 'SexualWellness/SafeSex',
  'สุขภาพทางเพศ/หนองในเทียม': 'SexualWellness/Chlamydia',
  'สุขภาพทางเพศ/โรคซิฟิลิส': 'SexualWellness/Syphilis',
  'สุขภาพทางเพศ/หนองในแท้': 'SexualWellness/Gonorrhea',
  'สุขภาพทางเพศ/โรคเริมที่อวัยวะเพศและเริมที่ปาก':
    'SexualWellness/GenitalOralHerpes',
  'สุขภาพทางเพศ/โรคติดเชื้อเอชพีวี': 'SexualWellness/HPV',
  'สุขภาพทางเพศ/โรคพยาธิในช่องคลอด': 'SexualWellness/Trichomoniasis',
  'สุขภาพทางเพศ/การติดเชื้อเอชไอวีและโรคเอดส์': 'SexualWellness/HIVAIDS',
  'สุขภาพทางเพศ/โรคติดต่อทางเพศสัมพันธ์': 'SexualWellness/MoreStisStds',
  'สุขภาพทางเพศ/การคุมกำเนิด-สุขภาพทางเพศ': 'SexualWellness/Contraception',
  'สุขภาพทางเพศ/เคล็ดลับเรื่องบนเตียง': 'SexualWellness/SexTips',
  ระบบประสาทและสมอง: 'BrainNervousSystem',
  'ระบบประสาทและสมอง/โรคลมชักและอาการชัก':
    'BrainNervousSystem/SeizureDisorders',
  'ระบบประสาทและสมอง/ภาวะสมองเสื่อมและโรคอัลไซเมอร์':
    'BrainNervousSystem/DementiaAlzheimerSDisease',
  'สมองและระบบประสาท/โรคปลอกประสาทเสื่อมแข็งหรือโรคเอ็มเอส':
    'BrainNervousSystem/MultipleSclerosis',
  'ระบบประสาทและสมอง/โรคพาร์กินสัน': 'BrainNervousSystem/ParkinsonSDisease',
  'ระบบประสาทและสมอง/โรคหลอดเลือดสมองหรือสโตรก':
    'BrainNervousSystem/StrokeAneurysm',
  'ระบบประสาทและสมอง/อาการปวดศีรษะและไมเกรน':
    'BrainNervousSystem/HeadachesMigraines',
  'ระบบประสาทและสมอง/ความผิดปกติทางสมองและกระดูกสันหลัง':
    'BrainNervousSystem/BrainSpineDisorders',
  'ระบบประสาทและสมอง/ความผิดปกติของระบบประสาทส่วนปลาย':
    'BrainNervousSystem/PeripheralNervousSystemDisorders',
  'ระบบประสาทและสมอง/ปัญหาระบบประสาทและสมองแบบอื่น':
    'BrainNervousSystem/OtherBrainNsIssues',
  โรคภูมิแพ้: 'Allergies',
  'โรคภูมิแพ้/ภูมิแพ้อาหาร': 'Allergies/FoodAllergies',
  'โรคภูมิแพ้/ภูมิแพ้จมูกและตา': 'Allergies/NoseEye',
  'โรคภูมิแพ้/ภูมิแพ้ผิวหนัง': 'Allergies/SkinAllergies',
  'โรคภูมิแพ้/ภูมิแพ้สัตว์และแมลง': 'Allergies/AnimalInsect',
  'โรคภูมิแพ้/ภูมิแพ้แบบอื่น': 'Allergies/OtherAllergies',
  โรคติดเชื้อ: 'InfectiousDiseases',
  'โรคติดเชื้อ/ไวรัสโคโรนา': 'InfectiousDiseases/Coronavirus',
  'โรคติดเชื้อ/การติดเชื้อในระบบทางเดินหายใจ':
    'InfectiousDiseases/RespiratoryInfections',
  'โรคติดเชื้อ/โรคติดเชื้อจากอาหาร': 'InfectiousDiseases/FoodborneInfections',
  'โรคติดเชื้อ/การติดเชื้อแบคทีเรียแบบอื่น':
    'InfectiousDiseases/OtherBacterialInfections',
  'โรคติดเชื้อ/โรคติดเชื้อจากอากาศ': 'InfectiousDiseases/AirborneInfections',
  'โรคติดเชื้อ/โรคไข้ซิกา': 'InfectiousDiseases/Zika',
  'โรคติดเชื้อ/โรคไข้เลือดออก-หรือไข้เลือดออกเดงกี':
    'InfectiousDiseases/Dengue',
  'โรคติดเชื้อ/การติดเชื้อจากแมลง': 'InfectiousDiseases/InfectionsFromInsects',
  'โรคติดเชื้อ/การติดเชื้อไวรัสแบบอื่น':
    'InfectiousDiseases/OtherViralInfections',
  // 'โรคติดเชื้อ/....': 'InfectiousDiseases/Meningitis',
  'โรคติดเชื้อ/โรคเริม': 'InfectiousDiseases/Herpes',
  // 'โรคติดเชื้อ/....': 'InfectiousDiseases/TyphoidFever',
  สุขภาพระบบทางเดินอาหาร: 'DigestiveHealth',
  // 'สุขภาพระบบทางเดินอาหาร/....': 'DigestiveHealth/StomachUlcer',
  'สุขภาพระบบทางเดินอาหาร/ท้องอืดท้องเฟ้อ': 'DigestiveHealth/BloatingGas',
  'สุขภาพระบบทางเดินอาหาร/ท้องผูก': 'DigestiveHealth/Constipation',
  'สุขภาพระบบทางเดินอาหาร/ท้องร่วง': 'DigestiveHealth/Diarrhea',
  'สุขภาพระบบทางเดินอาหาร/โรคลำไส้อักเสบเรื้อรัง':
    'DigestiveHealth/InflammatroyBowelDisease',
  'สุขภาพระบบทางเดินอาหาร/โรคลำไส้แปรปรวน':
    'DigestiveHealth/IrritableBowelSyndrome',
  'สุขภาพระบบทางเดินอาหาร/อาการแสบร้อนกลางอก': 'DigestiveHealth/Heartburn',
  'สุขภาพระบบทางเดินอาหาร/โรคกรดไหลย้อน': 'DigestiveHealth/Gerd',
  'สุขภาพระบบทางเดินอาหาร/โรคแผลในกระเพาะอาหาร':
    'DigestiveHealth/PepticUlcerDisease',
  'สุขภาพระบบทางเดินอาหาร/โรคกระเพาะอาหารอักเสบ': 'DigestiveHealth/Gastritis',
  // 'สุขภาพระบบทางเดินอาหาร/....': 'DigestiveHealth/StomachFlu',
  'สุขภาพระบบทางเดินอาหาร/ภาวะจุลินทรีย์ในลำไส้เล็กเติบโตมากผิดปกติ':
    'DigestiveHealth/Sibo',
  'สุขภาพระบบทางเดินอาหาร/โรคเกี่ยวกับถุงน้ำดี':
    'DigestiveHealth/GallbladderDisease',
  'สุขภาพระบบทางเดินอาหาร/โรคริดสีดวงทวาร': 'DigestiveHealth/Hemorrhoids',
  'สุขภาพระบบทางเดินอาหาร/โรคกระเพาะอาหารและลำไส้อักเสบ':
    'DigestiveHealth/Gastroenteritis',
  'สุขภาพระบบทางเดินอาหาร/ปัญหาสุขภาพช่องท้องแบบอื่น':
    'DigestiveHealth/OtherDigestiveHealthIssues',
  'สุขภาพระบบทางเดินอาหาร/โรคตับ': 'DigestiveHealth/LiverDiseases',
  'ออร์โธปิดิกส์-โรคกล้ามและกระดูก': 'Musculoskeletal',
  'ออร์โธปิดิกส์-โรคกล้ามและกระดูก/โรคกระดูกพรุน-ออร์โธปิดิกส์-โรคกล้ามและกระดูก':
    'Musculoskeletal/Osteoporosis',
  'ออร์โธปิดิกส์-โรคกล้ามและกระดูก/โรคข้ออักเสบ': 'Musculoskeletal/Arthritis',
  'ออร์โธปิดิกส์-โรคกล้ามและกระดูก/ศัลยกรรมกระดูกและข้อ':
    'Musculoskeletal/OrthopedicSurgery',
  'ออร์โธปิดิกส์-โรคกล้ามและกระดูก/กระดูกร้าว-กระดูกหัก':
    'Musculoskeletal/FracturesBrokenBones',
  'ออร์โธปิดิกส์-โรคกล้ามและกระดูก/ปวดกล้ามเนื้อและกระดูก':
    'Musculoskeletal/MusculoskeletalPain',
  'ออร์โธปิดิกส์-โรคกล้ามและกระดูก/โรคเอ็นและข้อต่อแบบอื่น':
    'Musculoskeletal/OtherJointTendonDiseases',
  'ออร์โธปิดิกส์-โรคกล้ามและกระดูก/โรคกระดูกแบบอื่น':
    'Musculoskeletal/OtherBoneDiseases',
  สุขภาพระบบทางเดินปัสสาวะ: 'UrologicalHealth',
  'สุขภาพระบบทางเดินปัสสาวะ/โรคไต': 'UrologicalHealth/KidneyDisease',
  'สุขภาพระบบทางเดินปัสสาวะ/ปัญหากระเพาะปัสสาวะ':
    'UrologicalHealth/BladderProblems',
  'สุขภาพระบบทางเดินปัสสาวะ/นิ่วในระบบทางเดินปัสสาวะ':
    'UrologicalHealth/UrinaryTractStones',
  'สุขภาพระบบทางเดินปัสสาวะ/ภาวะกลั้นปัสสาวะไม่ได้':
    'UrologicalHealth/UrinaryIncontinence',
  // 'สุขภาพระบบทางเดินปัสสาวะ/ภาวะกลั้นปัสสาวะไม่ได้':
  //   'UrologicalHealth/OtherUrologicalIssues',
  'สุขภาพระบบทางเดินปัสสาวะ/ปัญหาระบบทางเดินปัสสาวะแบบอื่น':
    'UrologicalHealth/ProstateHealth',
  'สุขภาพระบบทางเดินปัสสาวะ/การติดเชื้อทางเดินปัสสาวะ': 'UrologicalHealth/UTI',
  สุขภาพตา: 'EyeHealth',
  'สุขภาพตา/ความบกพร่องทางการมองเห็นและตาบอด': 'EyeHealth/VisionImpairmentLoss',
  'สุขภาพตา/โรคตา': 'EyeHealth/EyeDiseases',
  'สุขภาพตา/การดูแลสุขภาพตา': 'EyeHealth/EyeCare',
  'สุขภาพตา/ต้อหิน': 'EyeHealth/Glaucoma',
  'สุขภาพตา/ต้อกระจก': 'EyeHealth/Cataracts',
  'สุขภาพตา/ปัญหาตาแบบอื่น': 'EyeHealth/OtherEyeIssues',
  สุขภาพช่องปาก: 'OralHealth',
  'สุขภาพช่องปาก/โรคเหงือกและช่องปาก': 'OralHealth/GumMouthDiseases',
  'สุขภาพช่องปาก/ปัญหาสุุขภาพฟัน': 'OralHealth/DentalConditions',
  'สุขภาพช่องปาก/การดูแลสุขภาพช่องปาก': 'OralHealth/OralCare',
  'สุขภาพช่องปาก/ทันตกรรมเพื่อความงาม': 'OralHealth/CosmeticDentistry',
  'สุขภาพช่องปาก/การจัดฟัน': 'OralHealth/Orthodontics',
  'สุขภาพช่องปาก/ทันตกรรมสำหรับเด็ก': 'OralHealth/PediatricDentistry',
  'สุขภาพช่องปาก/ปัญหาสุขภาพช่องปากแบบอื่น': 'OralHealth/OtherOralHealthIssues',
  สุขภาพผิว: 'SkinHealth',
  'สุขภาพผิว/การดูแลเล็บ': 'SkinHealth/NailCare',
  'สุขภาพผิว/การดูแลเส้นผมและหนังศีรษะ': 'SkinHealth/HairScalpCare',
  'สุขภาพผิว/การดูแลและทำความสะอาดผิว': 'SkinHealth/SkinCareCleansing',
  'สุขภาพผิว/โรคผิวหนังติดเชื้อ': 'SkinHealth/InfectiousSkinDiseases',
  'สุขภาพผิว/สิว-สุขภาพผิว': 'SkinHealth/Acne',
  'สุขภาพผิว/โรคสะเก็ดเงิน': 'SkinHealth/Psoriasis',
  'สุขภาพผิว/โรคผิวหนังอักเสบ': 'SkinHealth/Dermatitis',
  'สุขภาพผิว/โรคผิวหนังแบบอื่น': 'SkinHealth/OtherSkinDiseases',
  โรคเบาหวาน: 'Diabetes',
  'โรคเบาหวาน/โรคเบาหวานชนิดที่-1': 'Diabetes/Type1Diabetes',
  'โรคเบาหวาน/โรคเบาหวานชนิดที่-2': 'Diabetes/Type2Diabetes',
  'โรคเบาหวาน/ภาวะแทรกซ้อนจากโรคเบาหวาน': 'Diabetes/DiabetesComplications',
  ความผิดปกติของเลือด: 'BloodDisorders',
  'ความผิดปกติของเลือด/ภาวะโลหิตจาง': 'BloodDisorders/Anemia',
  'ความผิดปกติของเลือด/โรคธาลัสซีเมีย': 'BloodDisorders/Thalassemia',
  'ความผิดปกติของเลือด/ฮีโมฟีเลีย-โรคเลือดไหลไม่หยุด':
    'BloodDisorders/Hemophilia',
  'ความผิดปกติของเลือด/ความผิดปกติของเกล็ดเลือด':
    'BloodDisorders/PlateletDisorder',
  'ความผิดปกติของเลือด/ความผิดปกติของเม็ดเลือดขาว':
    'BloodDisorders/WhiteBloodCellDisorder',
  'ความผิดปกติของเลือด/ความผิดปกติของเลือดแบบอื่น':
    'BloodDisorders/OtherBloodDisorders',
  'หู-คอ-จมูก': 'ENT',
  'หู-คอ-จมูก/โรคหู': 'ENT/EarConditions',
  'หู-คอ-จมูก/โรคจมูก': 'ENT/NoseConditions',
  'หู-คอ-จมูก/โรคคอ': 'ENT/ThroatConditions',
  สุขภาพ: 'Health',
  'สุขภาพ/ประกันสุขภาพ': 'Health/HealthInsurance',
  'สุขภาพ/ข่าวสารสุขภาพทั่วไป': 'Health/HealthNews',
  'สุขภาพ/อาการของโรค': 'Health/Symptoms',
  'สุขภาพ/ความรู้เกี่ยวกับสุขภาพทั่วไป': 'Health/GeneralHealthKnowledge',
  'สุขภาพ/รีวิวโรงพยาบาลและคุณหมอ': 'Health/HospitalDoctorReviews',
  'สุขภาพ/การทดสอบทางการแพทย์': 'Health/MedicalTests',
  'สุขภาพ/ขั้นตอนทางการแพทย์และการผ่าตัด': 'Health/MedicalProceduresSurgeries',
}

export const idID: { [k: string]: string } = {
  'obat-suplemen': 'ObatdanSuplemen',
  'herbal-alternatif': 'HerbalAlternatif',
  'herbal-alternatif/herbal': 'HerbalAlternatif/Herbal',
  'herbal-alternatif/alternatif': 'HerbalAlternatif/PengobatanAlternatif',
  nutrisi: 'Nutrisi',
  'nutrisi/berat-badan-turun': 'Nutrisi/TipsMenurunkanBB',
  'nutrisi/resep-sehat': 'Nutrisi/ResepMakananSehat',
  'nutrisi/obesitas': 'Nutrisi/Obesitas',
  'nutrisi/fakta-gizi': 'Nutrisi/FaktaGizi',
  'nutrisi/diet': 'Nutrisi/Diet',
  'nutrisi/gizi-olahraga': 'Nutrisi/GiziOlahraga',
  'nutrisi/tips-makan-sehat': 'Nutrisi/TipsMakanSehat',
  kebugaran: 'Kebugaran',
  'kebugaran/kardio': 'Kebugaran/Kardio',
  'kebugaran/kelenturan': 'Kebugaran/Kelenturan',
  'kebugaran/kekuatan': 'Kebugaran/Kekuatan',
  'kebugaran/tips-olahraga': 'Kebugaran/TipsOlahraga',
  'kebugaran/olahraga-lainnya': 'Kebugaran/OlahragaLainnya',
  'kebugaran/cedera-olahraga': 'Kebugaran/CederaOlahraga',
  'kebugaran/olahraga-berat-badan-turun': 'Kebugaran/OlahragaBBTurun',
  mental: 'Mental',
  'mental/kecanduan': 'Mental/Kecanduan',
  'mental/gangguan-kecemasan': 'Mental/GangguanKecemasan',
  'mental/gangguan-mood': 'Mental/GangguanMood',
  'mental/cegah-bunuh-diri': 'Mental/CegahBunuhDiri',
  'mental/stres': 'Mental/Stres',
  'mental/gangguan-makan': 'Mental/GangguanMakan',
  'mental/hubungan-harmonis': 'Mental/HubunganHarmonis',
  'saraf/masalah-perkembangan-dewasa': 'Mental/MasalahPerkembanganDewasa',
  'mental/mental-lainnya': 'Mental/MentalLainnya',
  'pola-tidur': 'PolaTidurSehat',
  'pola-tidur/tips-tidur': 'PolaTidurSehat/TipsTidur',
  'pola-tidur/sleep-apnea': 'PolaTidurSehat/SleepApnea',
  'pola-tidur/insomnia': 'PolaTidurSehat/Insomnia',
  'pola-tidur/gangguan-tidur': 'PolaTidurSehat/GangguanTidur',
  'hidup-sehat': 'HidupSehat',
  'hidup-sehat/berhenti-merokok': 'HidupSehat/BerhentiMerokok',
  'hidup-sehat/pertolongan-pertama': 'HidupSehat/PertolonganPertama',
  'hidup-sehat/kebersihan-diri': 'HidupSehat/KebersihanDiri',
  lansia: 'Lansia',
  'lansia/olahraga-lansia': 'Lansia/OlahragaLansia',
  'lansia/mental-lansia': 'Lansia/MentalLansia',
  'lansia/perawatan-lansia': 'Lansia/PerawatanLansia',
  'lansia/gizi-lansia': 'Lansia/GiziLansia',
  'lansia/masalah-lansia': 'Lansia/MasalahLansia',
  kehamilan: 'Kehamilan',
  'kehamilan/kesuburan': 'Kehamilan/Kesuburan',
  'kehamilan/kesuburan/program-hamil': 'Kehamilan/Kesuburan/ProgramHamil',
  'kehamilan/kesuburan/masalah-kesuburan':
    'Kehamilan/Kesuburan/MasalahKesuburan',
  'kehamilan/kesuburan/real-stories': 'Kehamilan/Kesuburan/RealStories',
  'kehamilan/kesuburan/kesuburan-lainnya':
    'Kehamilan/Kesuburan/KesuburanLainnya',
  'kehamilan/kandungan': 'Kehamilan/Kandungan',
  'kehamilan/kandungan/trimester-1': 'Kehamilan/Kandungan/Trimester1',
  'kehamilan/kandungan/trimester-2': 'Kehamilan/Kandungan/Trimester2',
  'kehamilan/kandungan/trimester-3': 'Kehamilan/Kandungan/Trimester3',
  'kehamilan/kandungan/masalah-kehamilan':
    'Kehamilan/Kandungan/MasalahKehamilan',
  'kehamilan/kandungan/prenatal': 'Kehamilan/Kandungan/Prenatal',
  'kehamilan/kandungan/cerita-ibu': 'Kehamilan/Kandungan/CeritaIbu',
  'kehamilan/melahirkan': 'Kehamilan/Melahirkan',
  'kehamilan/melahirkan/persiapan': 'Kehamilan/Melahirkan/Persiapan',
  'kehamilan/melahirkan/persalinan': 'Kehamilan/Melahirkan/Persalinan',
  'kehamilan/melahirkan/komplikasi-persalinan':
    'Kehamilan/Melahirkan/KomplikasiPersalinan',
  'kehamilan/melahirkan/pengalaman-melahirkan':
    'Kehamilan/Melahirkan/PengalamanMelahirkan',
  'kehamilan/perawatan-ibu': 'Kehamilan/PerawatanIbu',
  'kehamilan/perawatan-ibu/masa-nifas': 'Kehamilan/PerawatanIbu/MasaNifas',
  'kehamilan/perawatan-ibu/perawatan-tubuh':
    'Kehamilan/PerawatanIbu/PerawatanTubuh',
  'kehamilan/perawatan-ibu/suara-perempuan':
    'Kehamilan/PerawatanIbu/SuaraPerempuan',
  'kehamilan/perawatan-ibu/ibu-lainnya': 'Kehamilan/PerawatanIbu/IbuLainnya',
  parenting: 'Parenting',
  'parenting/bayi': 'Parenting/Bayi',
  'parenting/bayi/bayi-1-tahun-pertama': 'Parenting/Bayi/BayiSatuTahunPertama',
  'parenting/bayi/menyusui': 'Parenting/Bayi/Menyusui',
  'parenting/bayi/gizi-bayi': 'Parenting/Bayi/GiziBayi',
  'parenting/bayi/perawatan-bayi': 'Parenting/Bayi/PerawatanBayi',
  'parenting/bayi/bayi-prematur': 'Parenting/Bayi/BayiPrematur',
  'parenting/anak-1-sampai-5-tahun': 'Parenting/Anak1Sampai5Tahun',
  'parenting/anak-1-sampai-5-tahun/tumbuh-kembang-balita':
    'Parenting/Anak1Sampai5Tahun/TumbuhKembangBalita',
  'parenting/anak-1-sampai-5-tahun/perkembangan-balita':
    'Parenting/Anak1Sampai5Tahun/PerkembanganBalita',
  'parenting/anak-1-sampai-5-tahun/gizi-balita':
    'Parenting/Anak1Sampai5Tahun/GiziBalita',
  'parenting/anak-6-sampai-9-tahun': 'Parenting/Anak6Sampai9Tahun',
  'parenting/anak-6-sampai-9-tahun/tumbuh-kembang-anak':
    'Parenting/Anak6Sampai9Tahun/TumbuhKembangAnak',
  'parenting/anak-6-sampai-9-tahun/perkembangan-anak':
    'Parenting/Anak6Sampai9Tahun/PerkembanganAnak',
  'parenting/anak-6-sampai-9-tahun/gizi-anak':
    'Parenting/Anak6Sampai9Tahun/GiziAnak',
  'parenting/kesehatan-anak': 'Parenting/KesehatanAnak',
  'parenting/kesehatan-anak/imunisasi': 'Parenting/KesehatanAnak/Imunisasi',
  'parenting/kesehatan-anak/gejala-anak': 'Parenting/KesehatanAnak/GejalaAnak',
  'parenting/kesehatan-anak/infeksi-anak':
    'Parenting/KesehatanAnak/InfeksiAnak',
  'parenting/kesehatan-anak/malnutrisi': 'Parenting/KesehatanAnak/Malnutrisi',
  'parenting/kesehatan-anak/gangguan-perkembangan':
    'Parenting/KesehatanAnak/GangguanPerkembangan',
  'parenting/kesehatan-anak/saraf-anak': 'Parenting/KesehatanAnak/SarafAnak',
  'parenting/kesehatan-anak/pencernaan-anak':
    'Parenting/KesehatanAnak/PencernaanAnak',
  'parenting/kesehatan-anak/kulit-anak': 'Parenting/KesehatanAnak/KulitAnak',
  'parenting/kesehatan-anak/pernapasan-anak':
    'Parenting/KesehatanAnak/PernapasanAnak',
  'parenting/kesehatan-anak/penyakit-pada-anak':
    'Parenting/KesehatanAnak/PenyakitPadaAnak',
  'parenting/remaja': 'Parenting/Remaja',
  'parenting/remaja/tumbuh-kembang-remaja':
    'Parenting/Remaja/TumbuhKembangRemaja',
  'parenting/remaja/kesehatan-mental-remaja':
    'Parenting/Remaja/KesehatanMentalRemaja',
  'parenting/remaja/kesehatan-remaja': 'Parenting/Remaja/KesehatanRemaja',
  pria: 'Pria',
  'pria/gangguan-hormon-pria': 'Pria/GangguanHormonPria',
  'pria/impotensi': 'Pria/Impotensi',
  'pria/penyakit-peyronie': 'Pria/PenyakitPeyronie',
  'pria/penis': 'Pria/KesehatanPenis',
  'pria/penyakit-pria': 'Pria/PenyakitPria',
  wanita: 'Wanita',
  'wanita/pcos': 'Wanita/PCOS',
  'wanita/fibroid-rahim': 'Wanita/FibroidRahim',
  'wanita/jamur-vagina': 'Wanita/JamurVagina',
  'wanita/radang-panggul': 'Wanita/RadangPanggul',
  'wanita/gangguan-hormon-wanita': 'Wanita/GangguanHormonWanita',
  'wanita/menopause': 'Wanita/Menopause',
  'wanita/tes-kesehatan-wanita': 'Wanita/TesKesehatanWanita',
  'wanita/menstruasi': 'Wanita/Menstruasi',
  'wanita/penyakit-wanita': 'Wanita/PenyakitWanita',
  seks: 'Seks',
  'seks/seks-aman': 'Seks/SeksAman',
  'seks/klamidia': 'Seks/Klamidia',
  'seks/sifilis': 'Seks/Sifilis',
  'seks/gonore': 'Seks/Gonore',
  'seks/herpes-genital-dan-oral': 'Seks/HerpesGenitalOral',
  'seks/hpv': 'Seks/HPV',
  'seks/trikomoniasis': 'Seks/Trikomoniasis',
  'seks/hivaids': 'Seks/HIVAIDS',
  'seks/penyakit-menular-seksual': 'Seks/PenyakitMenularSeksual',
  'seks/kontrasepsi': 'Seks/Kontrasepsi',
  'seks/tips-seks': 'Seks/TipsSeks',
  saraf: 'Saraf',
  'saraf/epilepsi': 'Saraf/Epilepsi',
  'saraf/alzheimer': 'Saraf/Alzheimer',
  'saraf/multipel-sklerosis': 'Saraf/MultipelSklerosis',
  'saraf/parkinson': 'Saraf/Parkinson',
  'saraf/stroke': 'Saraf/Stroke',
  'saraf/sakit-kepala': 'Saraf/SakitKepala',
  'saraf/otak-tulang-belakang': 'Saraf/OtakTulangBelakang',
  'saraf/saraf-tepi': 'Saraf/SarafTepi',
  'saraf/saraf-lainnya': 'Saraf/SarafLainnya',
  alergi: 'Alergi',
  'alergi/makanan': 'Alergi/AlergiMakanan',
  'alergi/hidung-dan-mata': 'Alergi/AlergiHidungMata',
  'alergi/kulit': 'Alergi/AlergiKulit',
  'alergi/hewan-dan-serangga': 'Alergi/HewanSerangga',
  'alergi/alergi-lainnya': 'Alergi/PenyakitAlergiLainnya',
  infeksi: 'Infeksi',
  'infeksi/covid19': 'Infeksi/Covid19',
  'infeksi/infeksi-pernapasan': 'Infeksi/InfeksiPernapasan',
  'infeksi/infeksi-melalui-makanan': 'Infeksi/InfeksiMelaluiMakanan',
  'infeksi/infeksi-bakteri': 'Infeksi/InfeksiBakteri',
  'infeksi/infeksi-melalui-udara': 'Infeksi/InfeksiMelaluiUdara',
  'infeksi/zika': 'Infeksi/Zika',
  'infeksi/demam-berdarah': 'Infeksi/DemamBerdarah',
  'infeksi/infeksi-serangga': 'Infeksi/InfeksiSerangga',
  'infeksi/infeksi-virus': 'Infeksi/InfeksiVirus',
  'infeksi/meningitis': 'Infeksi/Meningitis',
  'infeksi/herpes': 'Infeksi/Herpes',
  'infeksi/tifus': 'Infeksi/Tipes',
  pencernaan: 'KesehatanPencernaan',
  'pencernaan/tukak-lambung': 'KesehatanPencernaan/TukakLambung',
  'pencernaan/perut-kembung-begah': 'KesehatanPencernaan/PerutKembungBegah',
  'pencernaan/konstipasi': 'KesehatanPencernaan/Konstipasi',
  'pencernaan/diare': 'KesehatanPencernaan/Diare',
  'pencernaan/radang-usus': 'KesehatanPencernaan/RadangUsus',
  'pencernaan/iritasi-usus-besar': 'KesehatanPencernaan/IritasiUsusBesar',
  'pencernaan/nyeri-ulu-hati': 'KesehatanPencernaan/NyeriUluHati',
  'pencernaan/gerd': 'KesehatanPencernaan/GERD',
  'pencernaan/tukak-saluran-cerna': 'KesehatanPencernaan/TukakSaluranCerna',
  'pencernaan/maag': 'KesehatanPencernaan/Maag',
  'pencernaan/flu-perut': 'KesehatanPencernaan/FluPerut',
  'pencernaan/sibo': 'KesehatanPencernaan/SIBO',
  'pencernaan/empedu': 'KesehatanPencernaan/Empedu',
  'pencernaan/ambeien': 'KesehatanPencernaan/Ambeien',
  'pencernaan/muntaber': 'KesehatanPencernaan/Muntaber',
  'pencernaan/pencernaan-lainnya': 'KesehatanPencernaan/PencernaanLainnya',
  'pencernaan/hati': 'KesehatanPencernaan/Hati',
  muskuloskeletal: 'KesehatanMuskuloskeletal',
  'muskuloskeletal/osteoporosis': 'KesehatanMuskuloskeletal/Osteoporosis',
  'muskuloskeletal/radang-sendi': 'KesehatanMuskuloskeletal/Arthritis',
  'muskuloskeletal/bedah-ortopedi': 'KesehatanMuskuloskeletal/BedahOrtopedi',
  'muskuloskeletal/patah-tulang': 'KesehatanMuskuloskeletal/PatahTulang',
  'muskuloskeletal/myalgia': 'KesehatanMuskuloskeletal/Myalgia',
  'muskuloskeletal/sendi-tendon-lainnya':
    'KesehatanMuskuloskeletal/SendiTendonLainnya',
  'muskuloskeletal/tulang-sendi-lainnya':
    'KesehatanMuskuloskeletal/GangguanMuskuloskeletal',
  urologi: 'Urologi',
  'urologi/ginjal': 'Urologi/Ginjal',
  'urologi/kandung-kemih': 'Urologi/KandungKemih',
  'urologi/batu-saluran-kemih': 'Urologi/BatuSaluranKemih',
  'urologi/inkontinensia-urin': 'Urologi/InkontinensiaUrin',
  'urologi/urologi-lainnya': 'Urologi/UrologiLainnya',
  'urologi/prostat': 'Urologi/Prostat',
  'urologi/infeksi-saluran-kemih': 'Urologi/InfeksiSaluranKemih',
  mata: 'KesehatanMata',
  'mata/gangguan-penglihatan': 'KesehatanMata/GangguanPenglihatan',
  'mata/penyakit-mata': 'KesehatanMata/PenyakitMata',
  'mata/perawatan-mata': 'KesehatanMata/PerawatanMata',
  'mata/glaukoma': 'KesehatanMata/Glaukoma',
  'mata/katarak': 'KesehatanMata/Katarak',
  'mata/mata-lainnya': 'KesehatanMata/MataLainnya',
  'gigi-mulut': 'GigiMulut',
  'gigi-mulut/gusi-mulut': 'GigiMulut/GusiMulut',
  'gigi-mulut/gigi': 'GigiMulut/Gigi',
  'gigi-mulut/perawatan-oral': 'GigiMulut/PerawatanOral',
  'gigi-mulut/perawatan-gigi': 'GigiMulut/PerawatanGigi',
  'gigi-mulut/ortodonti': 'GigiMulut/Ortodonti',
  'gigi-mulut/gigi-anak': 'GigiMulut/GigiAnak',
  'gigi-mulut/mulut-gigi-lainnya': 'GigiMulut/MulutGigiLainnya',
  'penyakit-kulit': 'PenyakitKulit',
  'penyakit-kulit/perawatan-kuku': 'PenyakitKulit/PerawatanKuku',
  'penyakit-kulit/perawatan-rambut': 'PenyakitKulit/PerawatanKulitKepala',
  'penyakit-kulit/perawatan-kulit': 'PenyakitKulit/PerawatanKulit',
  'penyakit-kulit/infeksi-kulit': 'PenyakitKulit/PenyakitInfeksiKulit',
  'penyakit-kulit/jerawat': 'PenyakitKulit/Jerawat',
  'penyakit-kulit/psoriasis': 'PenyakitKulit/Psoriasis',
  'penyakit-kulit/dermatitis': 'PenyakitKulit/Dermatitis',
  'penyakit-kulit/kulit-lainnya': 'PenyakitKulit/PenyakitKulitLainnya',
  diabetes: 'Diabetes',
  'diabetes/tipe-1': 'Diabetes/DiabetesTipe1',
  'diabetes/tipe-2': 'Diabetes/DiabetesTipe2',
  'diabetes/komplikasi-diabetes': 'Diabetes/GulaDarahNormal',
  'kelainan-darah': 'PenyakitKelainanDarah',
  'kelainan-darah/anemia': 'PenyakitKelainanDarah/Anemia',
  'kelainan-darah/thalasemia': 'PenyakitKelainanDarah/Thalasemia',
  'kelainan-darah/hemofilia': 'PenyakitKelainanDarah/Hemofilia',
  'kelainan-darah/trombosit': 'PenyakitKelainanDarah/KelainanTrombosit',
  'kelainan-darah/sel-darah-putih':
    'PenyakitKelainanDarah/KelainanSelDarahPutih',
  'kelainan-darah/darah-lainnya': 'PenyakitKelainanDarah/PenyakitDarahLainnya',
  tht: 'THT',
  'tht/telinga': 'THT/Hidung',
  'tht/hidung': 'THT/Telinga',
  'tht/tenggorokan': 'THT/Tenggorokan',
  sehat: 'Sehat',
  'sehat/asuransi': 'Sehat/Asuransi',
  'sehat/berita': 'Sehat/Berita',
  'sehat/gejala-umum': 'Sehat/GejalaUmum',
  'sehat/informasi-kesehatan': 'Sehat/InformasiKesehatan',
  'sehat/rumah-sakit': 'Sehat/RumahSakit',
  'sehat/tes-kesehatan': 'Sehat/TesKesehatan',
  'sehat/operasi': 'Sehat/Operasi',

  // used to be non-redundant
  jantung: 'Jantung',
  'jantung/hipertensi': 'Jantung/Hipertensi',
  'jantung/penyakit-jantung': 'Jantung/PenyakitJantung',
  'jantung/infeksi-jantung': 'Jantung/InfeksiJantung',
  'jantung/kolesterol': 'Jantung/Kolesterol',
  'jantung/gagal-jantung': 'Jantung/GagalJantung',
  'jantung/jantung-koroner': 'Jantung/PenyakitJantungKoroner',
  'jantung/aritmia': 'Jantung/Aritmia',
  'jantung/jantung-bawaan': 'Jantung/JantungBawaan',
  'jantung/katup-jantung': 'Jantung/KatupJantung',
  'jantung/aterosklerosis': 'Jantung/Aterosklerosis',
  'jantung/kardiomiopati': 'Jantung/Kardiomiopati',
  'jantung/jantung-lainnya': 'Jantung/PenyakitJantungLainnya',
  kanker: 'Kanker',
  'kanker/kanker-paru': 'Kanker/KankerParu',
  'kanker/kanker-usus-besar': 'Kanker/KankerUsusBesar',
  'kanker/kanker-lambung': 'Kanker/KankerLambung',
  'kanker/kanker-serviks': 'Kanker/KankerServiks',
  'kanker/kanker-prostat': 'Kanker/KankerProstat',
  'kanker/kanker-hati': 'Kanker/KankerHati',
  'kanker/kanker-kulit': 'Kanker/KankerKulit',
  'kanker/kanker-payudara': 'Kanker/KankerPayudara',
  'kanker/kanker-tulang': 'Kanker/KankerTulang',
  'kanker/kanker-kandung-kemih': 'Kanker/KankerKandungKemih',
  'kanker/kanker-tiroid': 'Kanker/KankerTiroid',
  'kanker/kanker-ovarium': 'Kanker/KankerOvarium',
  'kanker/kanker-darah': 'Kanker/KankerDarah',
  'kanker/kanker-pankreas': 'Kanker/KankerPankreas',
  'kanker/limfoma': 'Kanker/Limfoma',
  'kanker/kanker-otak': 'Kanker/KankerOtak',
  'kanker/kepala-dan-leher': 'Kanker/KepalaLeher',
  'kanker/kanker-lainnya': 'Kanker/PenyakitKankerLainnya',
  pernapasan: 'Pernapasan',
  'pernapasan/bronkitis-kronis': 'Pernapasan/BronkitisKronis',
  'pernapasan/emfisema': 'Pernapasan/Emfisema',
  'pernapasan/bronkiektasis': 'Pernapasan/Bronkiektasis',
  'pernapasan/asma': 'Pernapasan/Asma',
  'pernapasan/flu': 'Pernapasan/Flu',
  'pernapasan/tbc': 'Pernapasan/TBC',
  'pernapasan/pneumonia': 'Pernapasan/Pneumonia',
  'pernapasan/granuloma-paru': 'Pernapasan/GranulomaParu',
  'pernapasan/pilek': 'Pernapasan/Pilek',
  'pernapasan/bronkitis': 'Pernapasan/Bronkitis',
  'pernapasan/emboli-paru': 'Pernapasan/EmboliParu',
  'pernapasan/pernapasan-lainnya': 'Pernapasan/PenyakitPernapasanLainnya',
}
export const idID_nonRedundent: { [k: string]: string } = {}

const msMY: { [k: string]: string } = {
  'keadaan-alergi-autoimun': 'Allergies',
  'keadaan-alergi-autoimun/alahan-makanan': 'Allergies/FoodAllergies',
  'keadaan-alergi-autoimun/alahan-hidung-mata': 'Allergies/NoseEye',
  'keadaan-alergi-autoimun/alahan-kulit': 'Allergies/Skin',
  'keadaan-alergi-autoimun/alahan-binatang-serangga': 'Allergies/AnimalInsect',
  'keadaan-alergi-autoimun/alergi': 'Allergies/OtherAllergies',

  'gangguan-darah': 'BloodDisorders',
  'gangguan-darah/anemia-ms': 'BloodDisorders/Anemia',
  'gangguan-darah/talasemia': 'BloodDisorders/Thalassemia',
  'gangguan-darah/hemofilia': 'BloodDisorders/Hemophilia',
  'gangguan-darah/gangguan-platelet': 'BloodDisorders/PlateletDisorder',
  'gangguan-darah/sel-darah-putih': 'BloodDisorders/WhiteBloodCell',
  'gangguan-darah/darah-lain': 'BloodDisorders/OtherBloodDisorders',

  'masalah-neurologikal': 'BrainNS',
  'masalah-neurologikal/sawan': 'BrainNS/SeizureDisorders',
  'masalah-neurologikal/demensia-alzheimer': 'BrainNS/DementiaAlzheimer',
  'masalah-neurologikal/sklerosis': 'BrainNS/MultipleSclerosis',
  'masalah-neurologikal/parkinson': 'BrainNS/ParkinsonsDisease',
  'masalah-neurologikal/angin-ahmar-strok': 'BrainNS/StrokeAneurysm',
  'masalah-neurologikal/sakit-kepala': 'BrainNS/HeadachesMigraines',
  'masalah-neurologikal/otak-tulang-belakang': 'BrainNS/BrainSpineDisorders',
  'masalah-neurologikal/saraf-periferal':
    'BrainNS/PeripheralNervousSystemDisorders',
  'masalah-neurologikal/saraf-lain': 'BrainNS/OtherBrainNSIssues',

  kanser: 'Cancer',
  'kanser/kanser-paru-paru': 'Cancer/LungCancer',
  'kanser/kanser-kolorektal': 'Cancer/ColorectalCancer',
  'kanser/kanser-perut/ ': 'Cancer/StomachCancer',
  'kanser/kanser-serviks': 'Cancer/CervicalCancer',
  'kanser/kanser-prostat': 'Cancer/ProstateCancer',
  'kanser/kanser-hati': 'Cancer/LiverCancer',
  'kanser/kanser-kulit': 'Cancer/SkinCancer',
  'kanser/kanser-payudara': 'Cancer/BreastCancer',
  'kanser/kanser-tulang': 'Cancer/BoneCancer',
  'kanser/kanser-pundi-kencing': 'Cancer/BladderCancer',
  'kanser/penyakit-tiroid': 'Cancer/ThyroidCancer',
  'kanser/kanser-ovari': 'Cancer/OvarianCancer',
  'kanser/leukemia': 'Cancer/Leukemia',
  'kanser/kanser-pankreas': 'Cancer/PancreaticCancer',
  'kanser/limfoma': 'Cancer/Lymphoma',
  'kanser/tumor-otak': 'Cancer/BrainTumors',
  'kanser/kanser-leher-kepala': 'Cancer/HeadNeckCancer',
  'kanser/kanser-lain': 'Cancer/OtherCancers',

  'kencing-manis': 'Diabetes',
  'kencing-manis/diabetes-jenis-satu': 'Diabetes/Type1Diabetes',
  'kencing-manis/diabetes-jenis-dua': 'Diabetes/Type2Diabetes',
  'kencing-manis/komplikasi-diabetes': 'Diabetes/DiabetesComplications',

  'penyakit-perut-gastrousus': 'DigestiveHealth',
  'penyakit-perut-gastrousus/ulser-perut': 'DigestiveHealth/StomachUlcer',
  'penyakit-perut-gastrousus/perut-kembung': 'DigestiveHealth/BloatingGas',
  'penyakit-perut-gastrousus/sembelit': 'DigestiveHealth/Constipation',
  'penyakit-perut-gastrousus/cirit-birit': 'DigestiveHealth/Diarrhea',
  'penyakit-perut-gastrousus/radang-usus':
    'DigestiveHealth/InflammatroyBowelDisease',
  'penyakit-perut-gastrousus/ibs-rengsa-usus':
    'DigestiveHealth/IrritableBowelSyndrome',
  'penyakit-perut-gastrousus/pedih-ulu-hati': 'DigestiveHealth/Heartburn',
  'penyakit-perut-gastrousus/gerd': 'DigestiveHealth/GERD',
  'penyakit-perut-gastrousus/ulser-peptik':
    'DigestiveHealth/PepticUlcerDisease',
  'penyakit-perut-gastrousus/gastrik': 'DigestiveHealth/Gastritis',
  'penyakit-perut-gastrousus/selsema-perut': 'DigestiveHealth/StomachFlu',
  'penyakit-perut-gastrousus/sibo': 'DigestiveHealth/SIBO',
  'penyakit-perut-gastrousus/pundi-hempedu':
    'DigestiveHealth/GallbladderDisease',
  'penyakit-perut-gastrousus/buasir': 'DigestiveHealth/Hemorrhoids',
  'penyakit-perut-gastrousus/gastroenteritis':
    'DigestiveHealth/Gastroenteritis',
  'penyakit-perut-gastrousus/hati': 'DigestiveHealth/LiverDiseases',
  'penyakit-perut-gastrousus/penghadaman-lain':
    'DigestiveHealth/OtherDigestiveIssues',

  ubat: 'DrugsSupplements',

  'keadaan-telinga-hidung-tekak': 'EarNoseThroat',
  'keadaan-telinga-hidung-tekak/telinga': 'EarNoseThroat/Ear',
  'keadaan-telinga-hidung-tekak/hidung': 'EarNoseThroat/Nose',
  'keadaan-telinga-hidung-tekak/tekak': 'EarNoseThroat/ThroatConditions',

  'kesihatan-mata': 'EyeHealth',
  'kesihatan-mata/cacat-penglihatan': 'EyeHealth/VisionImpairmentLoss',
  'kesihatan-mata/penyakit-mata': 'EyeHealth/EyeDiseases',
  'kesihatan-mata/penjagaan': 'EyeHealth/EyeCare',
  'kesihatan-mata/glaukoma': 'EyeHealth/Glaucoma',
  'kesihatan-mata/katarak': 'EyeHealth/Cataracs',
  'kesihatan-mata/masalah-lain': 'EyeHealth/OtherEyeIssues',

  kesihatan: 'Health',
  'kesihatan/insurans': 'Health/Insurance',
  'kesihatan/berita': 'Health/News',
  'kesihatan/simptom': 'Health/Symptoms',
  'kesihatan/fakta-menarik': 'Health/GeneralHealthKnowledge',
  'kesihatan/review-hospital-doktor': 'Health/Hospital',
  'kesihatan/ujian-kesihatan': 'Health/MedicalTests',
  'kesihatan/pembedahan': 'Health/Surgeries',

  kecergasan: 'HealthFitness',
  'kecergasan/kardio-ketahanan': 'HealthFitness/CardioEndurance',
  'kecergasan/kelenturan-keseimbangan': 'HealthFitness/BalanceFlexibility',
  'kecergasan/kekuatan-fizikal': 'HealthFitness/StrengthTraining',
  'kecergasan/tips-keselamatan': 'HealthFitness/ExerciseSafetyTips',
  'kecergasan/motivasi-bersenam': 'HealthFitness/FitnessMotivation',
  'kecergasan/turun-berat': 'HealthFitness/WeightLossExercises',
  'kecergasan/aktiviti-lain': 'HealthFitness/OtherFitnessActivities',

  'penjagaan-warga-emas': 'HealthyAging',
  'penjagaan-warga-emas/aktif': 'HealthyAging/ActiveAging',
  'penjagaan-warga-emas/minda': 'HealthyAging/AgingMind',
  'penjagaan-warga-emas/badan': 'HealthyAging/AgingBody',
  'penjagaan-warga-emas/pemakanan-usia-emas': 'HealthyAging/NutritionForAging',
  'penjagaan-warga-emas/masalah-kesihatan':
    'HealthyAging/CommonAgingConditions',

  pemakanan: 'HealthyEating',
  'pemakanan/diet-pengurusan-berat-badan': 'HealthyEating/DietWeightLoss',
  'pemakanan/resipi-sihat': 'HealthyEating/HealthyRecipes',
  'pemakanan/obesiti': 'HealthyEating/Obesity',
  'pemakanan/fakta-nutrisi': 'HealthyEating/NutritionFacts',
  'pemakanan/diet-sihat': 'HealthyEating/SpecialDiets',
  'pemakanan/pemakanan-sukan': 'HealthyEating/SportsNutrition',
  'pemakanan/tips-lain': 'HealthyEating/OtherHealthyEatingTips',

  'habit-sihat': 'HealthyHabits',
  'habit-sihat/berhenti-merokok': 'HealthyHabits/QuitSmoking',
  'habit-sihat/pertolongan-cemas': 'HealthyHabits/FirstAid',
  'habit-sihat/kebersihan-diri': 'HealthyHabits/GeneralHygiene',

  'kesihatan-mental': 'HealthyMind',
  'kesihatan-mental/ketagihan': 'HealthyMind/Addiction',
  'kesihatan-mental/gangguan-kegelisahan': 'HealthyMind/AnxietyDisorder',
  'kesihatan-mental/gangguan-mood': 'HealthyMind/MoodDisorder',
  'kesihatan-mental/cegah-bunuh-diri': 'HealthyMind/SuicidePrevention',
  'kesihatan-mental/pengurusan-stress': 'HealthyMind/StressManagement',
  'kesihatan-mental/gangguan-pemakanan': 'HealthyMind/EatingDisorders',
  'kesihatan-mental/hubungan-yang-sihat': 'HealthyMind/HealthyRelationships',
  'kesihatan-mental/gangguan-perkembangan': 'HealthyMind/DevelopmentalDisorder',
  'kesihatan-mental/kesihatan-mental-lain':
    'HealthyMind/OtherMentalHealthIssues',

  tidur: 'HealthySleep',
  'tidur/tidur-nyenyak': 'HealthySleep/AGoodNightsSleep',
  'tidur/apnea-tidur': 'HealthySleep/SleepApnea',
  'tidur/insomnia': 'HealthySleep/Insomnia',
  'tidur/gangguan-tidur': 'HealthySleep/SleepDisorders',

  'penyakit-jantung': 'HeartHealth',
  'penyakit-jantung/tekanan-darah': 'HeartHealth/Hypertension',
  'penyakit-jantung/sakit-jantung': 'HeartHealth/HeartDisease',
  'penyakit-jantung/jangkitan-jantung': 'HeartHealth/HeartInfections',
  'penyakit-jantung/kolesterol': 'HeartHealth/Cholesterol',
  'penyakit-jantung/kegagalan-jantung': 'HeartHealth/HeartFailure',
  'penyakit-jantung/jantung-koronari': 'HeartHealth/CoronaryArteryDisease',
  'penyakit-jantung/degupan-jantung': 'HeartHealth/HeartArrhythmias',
  'penyakit-jantung/jantung-kongenital': 'HeartHealth/CongenitalHeartDisease',
  'penyakit-jantung/injap-jantung': 'HeartHealth/HeartValve',
  'penyakit-jantung/aterosklerosis': 'HeartHealth/Atherosclerosis',
  'penyakit-jantung/kardiomiopati': 'HeartHealth/Cardiomyopathy',
  'penyakit-jantung/isu-lain': 'HeartHealth/OtherCardiovascularIssues',

  herba: 'HerbalAlternatives',
  'herba/ubatan-herba': 'HerbalAlternatives/Herbal',
  'herba/rawatan-alternatif': 'HerbalAlternatives/Alternatives',

  berjangkit: 'InfectiousDiseases',
  'berjangkit/covid19': 'InfectiousDiseases/Coronavirus',
  'berjangkit/jangkitan-pernafasan': 'InfectiousDiseases/RespiratoryInfections',
  'berjangkit/keracunan-makanan': 'InfectiousDiseases/FoodborneInfections',
  'berjangkit/jangkitan-lain': 'InfectiousDiseases/OtherBacterialInfections',
  'berjangkit/jangkitan-udara': 'InfectiousDiseases/AirborneInfections',
  'berjangkit/zika': 'InfectiousDiseases/Zika',
  'berjangkit/denggi': 'InfectiousDiseases/Dengue',
  'berjangkit/jangkitan-serangga': 'InfectiousDiseases/InfectionsFromInsects',
  'berjangkit/virus-lain': 'InfectiousDiseases/OtherViralInfections',
  'berjangkit/meningitis': 'InfectiousDiseases/Meningitis',
  'berjangkit/herpes': 'InfectiousDiseases/Herpes',
  'berjangkit/demam-kepialu': 'InfectiousDiseases/TyphoidFever',

  'kesihatan-lelaki': 'MensHealth',
  'kesihatan-lelaki/hormon-lelaki': 'MensHealth/HormoneIssues',
  'kesihatan-lelaki/mati-pucuk': 'MensHealth/ErectileDisfunction',
  'kesihatan-lelaki/penyakit-peyronie': 'MensHealth/PeyroniesDisease',
  'kesihatan-lelaki/penjagaan-zakar': 'MensHealth/PenisHealth',
  'kesihatan-lelaki/lelaki-lain': 'MensHealth/HealthIssues',

  'kesihatan-mulut': 'OralHealth',
  'kesihatan-mulut/gusi-mulut': 'OralHealth/GumMouth',
  'kesihatan-mulut/keadaan-gigi': 'OralHealth/DentalConditions',
  'kesihatan-mulut/penjagaan-mulut': 'OralHealth/OralCare',
  'kesihatan-mulut/pergigian-kosmetik': 'OralHealth/CosmeticDentistry',
  'kesihatan-mulut/ortodontik': 'OralHealth/Orthodontics',
  'kesihatan-mulut/gigi-kanak-kanak': 'OralHealth/PediatricDentistry',
  'kesihatan-mulut/mulut-lain': 'OralHealth/OtherOralHealthIssues',

  'penyakit-muskuloskeletal': 'Musculoskeletal',
  'penyakit-muskuloskeletal/osteoperosis-ms': 'Musculoskeletal/Osteoporosis',
  'penyakit-muskuloskeletal/artritis': 'Musculoskeletal/Arthritis',
  'penyakit-muskuloskeletal/pembedahan-tulang':
    'Musculoskeletal/OrthopedicSurgery',
  'penyakit-muskuloskeletal/patah-tulang':
    'Musculoskeletal/FracturesBrokenBones',
  'penyakit-muskuloskeletal/sakit-otot': 'Musculoskeletal/MusculoskeletalPain',
  'penyakit-muskuloskeletal/masalah-otot-lain':
    'Musculoskeletal/OtherJointTendonDiseases',
  'penyakit-muskuloskeletal/penyakit-tulang-lain':
    'Musculoskeletal/OtherBoneDiseases',

  keibubapaan: 'parenting',
  'keibubapaan/bayi': 'parenting/Baby',
  'keibubapaan/bayi/pemakanan-bayi': 'parenting/Baby/BabyNutrition',
  'keibubapaan/bayi/tahun-pertama-bayi': 'parenting/Baby/BabysFirstYear',
  'keibubapaan/bayi/penyusuan': 'parenting/Baby/Breastfeeding',
  'keibubapaan/bayi/penjagaan-bayi': 'parenting/Baby/BabyCare',
  'keibubapaan/bayi/bayi-pramatang': 'parenting/Baby/PrematureBabies',
  'keibubapaan/kanak-kanak': 'parenting/ToddlerPreschooler',
  'keibubapaan/kanak-kanak/tumbesaran':
    'parenting/ToddlerPreschooler/Milestones',
  'keibubapaan/kanak-kanak/perkembangan':
    'parenting/ToddlerPreschooler/GrowthDevelopment',
  'keibubapaan/kanak-kanak/pemakanan-anak':
    'parenting/ToddlerPreschooler/Nutrition',
  'keibubapaan/budak-tadika': 'parenting/SchoolAgeChildren',
  'keibubapaan/budak-tadika/tumbesaran-anak':
    'parenting/SchoolAgeChildren/Milestones',
  'keibubapaan/budak-tadika/perkembangan-anak':
    'parenting/SchoolAgeChildren/GrowthDevelopment',
  'keibubapaan/budak-tadika/pemakanan-budak':
    'parenting/SchoolAgeChildren/Nutrition',
  'keibubapaan/kesihatan-anak': 'parenting/ChildHealth',
  'keibubapaan/kesihatan-anak/vaksin': 'parenting/ChildHealth/Vaccines',
  'keibubapaan/kesihatan-anak/penyakit': 'parenting/ChildHealth/CommonSymptoms',
  'keibubapaan/kesihatan-anak/penyakit-berjangkit':
    'parenting/ChildHealth/InfectiousDiseases',
  'keibubapaan/kesihatan-anak/malnutrasi': 'parenting/ChildHealth/Malnutrition',
  'keibubapaan/kesihatan-anak/gangguan-perkembangan-anak':
    'parenting/ChildHealth/BehavioralDevelopmentalDisorders',
  'keibubapaan/kesihatan-anak/penyakit-neurologi':
    'parenting/ChildHealth/NeurologicalDiseases',
  'keibubapaan/kesihatan-anak/masalah-penghadaman':
    'parenting/ChildHealth/DigestiveProblems',
  'keibubapaan/kesihatan-anak/penyakit-kulit-anak':
    'parenting/ChildHealth/SkinDiseases',
  'keibubapaan/kesihatan-anak/saluran-pernafasan-anak':
    'parenting/ChildHealth/RespiratoryDiseases',
  'keibubapaan/kesihatan-anak/kesihatan-anak-lain':
    'parenting/ChildHealth/OtherChildHealthIssues',
  'keibubapaan/remaja': 'parenting/Adolescents',
  'keibubapaan/remaja/perkembangan-remaja':
    'parenting/Adolescents/MilestonesDevelopment',
  'keibubapaan/remaja/kesihatan-mental-remaja':
    'parenting/Adolescents/MentalHealth',
  'keibubapaan/remaja/kesihatan-remaja': 'parenting/Adolescents/Health',

  kehamilan: 'pregnancy',
  'kehamilan/rancang-kehamilan': 'pregnancy/GettingPregnant',
  'kehamilan/rancang-kehamilan/cabaran':
    'pregnancy/GettingPregnant/FertilityProblemsTreatment',
  'kehamilan/rancang-kehamilan/kisah-benar':
    'pregnancy/GettingPregnant/RealStories',
  'kehamilan/rancang-kehamilan/lain-lain':
    'pregnancy/GettingPregnant/OtherConceptionTopics',
  'kehamilan/rancang-kehamilan/persediaan-kehamilan':
    'pregnancy/GettingPregnant/PregnantPreparation',
  'kehamilan/tips-hamil': 'pregnancy/BeingPregnant',
  'kehamilan/tips-hamil/penjagaan-kehamilan':
    'pregnancy/BeingPregnant/PrenatalCare',
  'kehamilan/tips-hamil/trimester-pertama':
    'pregnancy/BeingPregnant/FirstTrimester',
  'kehamilan/tips-hamil/trimester-kedua':
    'pregnancy/BeingPregnant/SecondTrimester',
  'kehamilan/tips-hamil/trimester-ketiga':
    'pregnancy/BeingPregnant/ThirdTrimester',
  'kehamilan/tips-hamil/masalah-kehamilan':
    'pregnancy/BeingPregnant/pregnancyProblems',
  'kehamilan/tips-hamil/pengalaman-mengandung':
    'pregnancy/BeingPregnant/MyStory',
  'kehamilan/kelahiran-bayi': 'pregnancy/GivingBirth',
  'kehamilan/kelahiran-bayi/persediaan': 'pregnancy/GivingBirth/Preparing',
  'kehamilan/kelahiran-bayi/beranak': 'pregnancy/GivingBirth/LaborDelivery',
  'kehamilan/kelahiran-bayi/komplikasi': 'pregnancy/GivingBirth/Complications',
  'kehamilan/kelahiran-bayi/pengalaman-bersalin':
    'pregnancy/GivingBirth/BirthStories',
  'kehamilan/penjagaan-ibu-hamil': 'pregnancy/MotherCare',
  'kehamilan/penjagaan-ibu-hamil/selepas-bersalin':
    'pregnancy/MotherCare/PostpartumPeriod',
  'kehamilan/penjagaan-ibu-hamil/penjagaan-lepas-bersalin':
    'pregnancy/MotherCare/PostpartumSelfcare',
  'kehamilan/penjagaan-ibu-hamil/kesihatan-minda':
    'pregnancy/MotherCare/MentalHealth',
  'kehamilan/penjagaan-ibu-hamil/suara-wanita':
    'pregnancy/MotherCare/WomansVoice',
  'kehamilan/penjagaan-ibu-hamil/penjagaan-lain':
    'pregnancy/MotherCare/OtherMothercareTopics',

  'penyakit-batuk-saluran-pernafasan': 'RespiratoryHealth',
  'penyakit-batuk-saluran-pernafasan/bronkitis-kronik':
    'RespiratoryHealth/ChronicBronchitis',
  'penyakit-batuk-saluran-pernafasan/emfisema': 'RespiratoryHealth/Emphysema',
  'penyakit-batuk-saluran-pernafasan/bronkiektasis':
    'RespiratoryHealth/Bronchiectasis',
  'penyakit-batuk-saluran-pernafasan/asma': 'RespiratoryHealth/Asthma',
  'penyakit-batuk-saluran-pernafasan/influenza': 'RespiratoryHealth/Influenza',
  'penyakit-batuk-saluran-pernafasan/batuk-kering':
    'RespiratoryHealth/Tuberculosis',
  'penyakit-batuk-saluran-pernafasan/pneumonia': 'RespiratoryHealth/Pneumonia',
  'penyakit-batuk-saluran-pernafasan/granuloma':
    'RespiratoryHealth/LungGranulomas',
  'penyakit-batuk-saluran-pernafasan/selesema-flu': 'RespiratoryHealth/Cold',
  'penyakit-batuk-saluran-pernafasan/bronkitis': 'RespiratoryHealth/Bronchitis',
  'penyakit-batuk-saluran-pernafasan/embolisme-pulmonari':
    'RespiratoryHealth/PulmonaryEmbolism',
  'penyakit-batuk-saluran-pernafasan/pernafasan-lain':
    'RespiratoryHealth/OtherRespiratoryIssues',

  'seks-hubungan': 'SexualWellness',
  'seks-hubungan/seks-selamat': 'SexualWellness/SafeSex',
  'seks-hubungan/chlamydia': 'SexualWellness/Chlamydia',
  'seks-hubungan/sifilis': 'SexualWellness/Syphilis',
  'seks-hubungan/gonorea': 'SexualWellness/Gonorrhea',
  'seks-hubungan/herpes-kemaluan': 'SexualWellness/GenitalHerpes',
  'seks-hubungan/hpv': 'SexualWellness/HPV',
  'seks-hubungan/trikomoniasis': 'SexualWellness/Trichomonas',
  'seks-hubungan/hiv-aids-ms': 'SexualWellness/HIVAIDS',
  'seks-hubungan/std-sti': 'SexualWellness/STIsSTDs',
  'seks-hubungan/kontrasepsi': 'SexualWellness/Contraception',
  'seks-hubungan/petua-seks': 'SexualWellness/SexTips',

  'sihat-bergaya': 'SkinHealth',
  'sihat-bergaya/penjagaan-kuku': 'SkinHealth/NailCare',
  'sihat-bergaya/penjagaan-rambut': 'SkinHealth/HairScalpCare',
  'sihat-bergaya/penjagaan-kulit': 'SkinHealth/SkinCareCleansing',
  'sihat-bergaya/penyakit-kulit': 'SkinHealth/InfectiousSkin',
  'sihat-bergaya/jerawat': 'SkinHealth/Acne',
  'sihat-bergaya/psoriasis': 'SkinHealth/Psoriasis',
  'sihat-bergaya/dermatitis': 'SkinHealth/Dermatitis',
  'sihat-bergaya/masalah-kulit': 'SkinHealth/OtherSkinDiseases',

  urologi: 'UrologicalHealth',
  'urologi/penyakit-buah-pinggang': 'UrologicalHealth/KidneyDisease',
  'urologi/masalah-pundi-kencing': 'UrologicalHealth/BladderProblems',
  'urologi/batu-karang': 'UrologicalHealth/UrinaryTrackStones',
  'urologi/kencing-tak-lawas': 'UrologicalHealth/UrinaryIncontinence',
  'urologi/prostat': 'UrologicalHealth/ProstateHealth',
  'urologi/masalah-urologi': 'UrologicalHealth/OtherUrologicalIssues',
  'urologi/jangkitan-saluran-kencing': 'UrologicalHealth/UTI',

  'kesihatan-wanita': 'WomensHealth',
  'kesihatan-wanita/pcos': 'WomensHealth/PCOS',
  'kesihatan-wanita/fibroid-rahim': 'WomensHealth/MyomaCysts',
  'kesihatan-wanita/hormon-wanita': 'WomensHealth/FemaleHormonalImbalance',
  'kesihatan-wanita/vaginitis': 'WomensHealth/Vaginitis',
  'kesihatan-wanita/otot-pelvik': 'WomensHealth/PelvicRelatedIssue',
  'kesihatan-wanita/menopaus': 'WomensHealth/Menopause',
  'kesihatan-wanita/pemeriksaan-wanita': 'WomensHealth/ScreeningTests',
  'kesihatan-wanita/haid': 'WomensHealth/Menstruation',
  'kesihatan-wanita/wanita-lain': 'WomensHealth/OtherWomensIssues',

  'health-tools': 'HealthTools',
  'health-tools/kalkulator-bmi': 'HealthTools/BMI',
  'health-tools/kalkulator-bmr': 'HealthTools/BMR',
  'health-tools/kalkulator-kesuburan': 'HealthTools/OvulationCalculator',
  'health-tools/ms/alatan-ukur-kesihatan/kalkulator-kadar-jantung-sasaran':
    'HealthTools/HeartRate',
  'health-tools/ms/alatan-ukur-kesihatan/kira-kandungan-alkohol-dalam-darah-anda-bac':
    'HealthTools/BAC',
  'health-tools/ms/alatan-ukur-kesihatan/kalkulator-perbelanjaan-merokok':
    'HealthTools/SmokingCostCalculator',
  'health-tools/ms/alatan-ukur-kesihatan/kenali-najis-bayi-anda':
    'HealthTools/BabysFeces',
  'health-tools/ms/alatan-ukur-kesihatan/kalkulator-tambah-berat-badan-hamil':
    'HealthTools/PregnancyWeight',
  'health-tools/ms/alatan-ukur-kesihatan/kadar-pembakaran-kalori':
    'HealthTools/CaloriesCalculator',
  'health-tools/kalkulator-tarikh-bersalin': 'HealthTools/BirthDateCalculator',
  'health-tools/alat-kesihatan-vaksin': 'HealthTools/ImmunizationSchedule',
}

export const viVN: { [k: string]: string } = {
  'di-ung': 'Allergies',
  'di-ung/di-ung-thuc-an': 'Allergies/FoodAllergies',
  'di-ung/di-ung-mat-mui': 'Allergies/NoseEye',
  'di-ung/di-ung-da': 'Allergies/Skin',
  'di-ung/di-ung-dong-vat-con-trung': 'Allergies/AnimalInsect',
  'di-ung/di-ung-khac': 'Allergies/OtherAllergies',
  'benh-ve-mau': 'BloodDisorders',
  'benh-ve-mau/thieu-mau': 'BloodDisorders/Anemia',
  'benh-ve-mau/thalassemia-tan-mau-bam-sinh': 'BloodDisorders/Thalassemia',
  'benh-ve-mau/hemophilia-mau-kho-dong': 'BloodDisorders/Hemophilia',
  'benh-ve-mau/roi-loan-tieu-cau': 'BloodDisorders/PlateletDisorder',
  'benh-ve-mau/benh-bach-cau': 'BloodDisorders/WhiteBloodCell',
  'benh-ve-mau/van-de-mau-khac': 'BloodDisorders/OtherBloodDisorders',
  'benh-nao-he-than-kinh': 'BrainNS',
  'benh-nao-he-than-kinh/roi-loan-co-giat': 'BrainNS/SeizureDisorders',
  'benh-nao-he-than-kinh/sa-sut-tri-tue-alzheimer': 'BrainNS/DementiaAlzheimer',
  'benh-nao-he-than-kinh/da-xo-cung': 'BrainNS/MultipleSclerosis',
  'benh-nao-he-than-kinh/benh-parkinson': 'BrainNS/ParkinsonsDisease',
  'benh-nao-he-than-kinh/dot-quy-phinh-mach-nao': 'BrainNS/StrokeAneurysm',
  'benh-nao-he-than-kinh/dau-dau-dau-nua-dau': 'BrainNS/HeadachesMigraines',
  'benh-nao-he-than-kinh/van-de-nao-cot-song': 'BrainNS/BrainSpineDisorders',
  'benh-nao-he-than-kinh/van-de-than-kinh-ngoai-bien':
    'BrainNS/PeripheralNervousSystemDisorders',
  'benh-nao-he-than-kinh/van-de-nao-than-kinh': 'BrainNS/OtherBrainNSIssues',
  'ung-thu-ung-buou': 'Cancer',
  'ung-thu-ung-buou/ung-thu-vu': 'Cancer/BreastCancer',
  'ung-thu-ung-buou/ung-thu-phoi': 'Cancer/LungCancer',
  'ung-thu-ung-buou/ung-thu-dai-truc-trang': 'Cancer/ColorectalCancer',
  'ung-thu-ung-buou/ung-thu-da-day': 'Cancer/StomachCancer',
  'ung-thu-ung-buou/ung-thu-co-tu-cung': 'Cancer/CervicalCancer',
  'ung-thu-ung-buou/ung-thu-tuyen-tien-liet': 'Cancer/ProstateCancer',
  'ung-thu-ung-buou/ung-thu-gan': 'Cancer/LiverCancer',
  'ung-thu-ung-buou/ung-thu-da': 'Cancer/SkinCancer',
  'ung-thu-ung-buou/ung-thu-xuong': 'Cancer/BoneCancer',
  'ung-thu-ung-buou/ung-thu-bang-quang': 'Cancer/BladderCancer',
  'ung-thu-ung-buou/ung-thu-tuyen-giap': 'Cancer/ThyroidCancer',
  'ung-thu-ung-buou/ung-thu-buong-trung': 'Cancer/OvarianCancer',
  'ung-thu-ung-buou/ung-thu-mau': 'Cancer/Leukemia',
  'ung-thu-ung-buou/ung-thu-tuyen-tuy': 'Cancer/PancreaticCancer',
  'ung-thu-ung-buou/u-nao': 'Cancer/BrainTumors',
  'ung-thu-ung-buou/ung-thu-khac': 'Cancer/OtherCancers',
  'ung-thu-ung-buou/u-lympho': 'Cancer/Lymphoma',
  'ung-thu-ung-buou/ung-thu-dau-co': 'Cancer/HeadNeckCancer',
  'tieu-duong-dai-thao-duong': 'Diabetes',
  'tieu-duong-dai-thao-duong/tieu-duong-type-1': 'Diabetes/Type1',
  'tieu-duong-dai-thao-duong/tieu-duong-type-2': 'Diabetes/Type2',
  'tieu-duong-dai-thao-duong/bien-chung-tieu-duong':
    'Diabetes/DiabetesComplications',
  'benh-tieu-hoa': 'digestivehealth',
  'benh-tieu-hoa/tieu-chay': 'digestivehealth/Diarrhea',
  'benh-tieu-hoa/tao-bon': 'digestivehealth/Constipation',
  'benh-tieu-hoa/viem-da-day': 'digestivehealth/Gastritis',
  'benh-tieu-hoa/loet-da-day': 'digestivehealth/StomachUlcer',
  'benh-tieu-hoa/day-bung-o-hoi': 'digestivehealth/BloatingGas',
  'benh-tieu-hoa/viem-ruot': 'digestivehealth/InflammatroyBowelDisease',
  'benh-tieu-hoa/hoi-chung-ruot-kich-thich':
    'digestivehealth/IrritableBowelSyndrome',
  'benh-tieu-hoa/o-nong': 'digestivehealth/Heartburn',
  'benh-tieu-hoa/trao-nguoc-da-day-thuc-quan': 'digestivehealth/GERD',
  'benh-tieu-hoa/loet-da-day-ta-trang': 'digestivehealth/PepticUlcerDisease',
  'benh-tieu-hoa/cum-da-day': 'digestivehealth/StomachFlu',
  'benh-tieu-hoa/loan-khuan-o-ruot-non': 'digestivehealth/SIBO',
  'benh-tieu-hoa/soi-mat': 'digestivehealth/GallbladderDisease',
  'benh-tieu-hoa/benh-tri': 'digestivehealth/Hemorrhoids',
  'benh-tieu-hoa/viem-da-day-ruot': 'digestivehealth/Gastroenteritis',
  'benh-tieu-hoa/van-de-tieu-hoa-khac': 'digestivehealth/OtherDigestiveIssues',
  'benh-tieu-hoa/benh-gan': 'digestivehealth/LiverDiseases',
  thuoc: 'drugssupplements',
  'benh-tai-mui-hong': 'EarNoseThroat',
  'benh-tai-mui-hong/benh-ve-tai': 'EarNoseThroat/Ear',
  'benh-tai-mui-hong/benh-ve-mui': 'EarNoseThroat/Nose',
  'benh-tai-mui-hong/benh-ve-hong': 'EarNoseThroat/ThroatConditions',
  'nhan-khoa': 'eyehealth',
  'nhan-khoa/suy-giam-mat-thi-luc': 'eyehealth/VisionImpairmentLoss',
  'nhan-khoa/benh-nhan-khoa': 'eyehealth/EyeDiseases',
  'nhan-khoa/cham-soc-mat': 'eyehealth/EyeCare',
  'nhan-khoa/cuom-nuoc-glocom': 'eyehealth/Glaucoma',
  'nhan-khoa/duc-thuy-tinh-the': 'eyehealth/Cataracs',
  'nhan-khoa/cac-van-de-ve-mat-khac': 'eyehealth/OtherEyeIssues',
  'suc-khoe': 'Health',
  'suc-khoe/xet-nghiem-y-khoa': 'Health/MedicalTests',
  'suc-khoe/phau-thuat': 'Health/Surgeries',
  'suc-khoe/ban-tin-suc-khoe': 'Health/News',
  'suc-khoe/benh-vien': 'Health/Hospital',
  'suc-khoe/bao-hiem-suc-khoe': 'Health/Insurance',
  'suc-khoe/hoi-de-khoe-hon': 'Health/AskToGetBetterForSanofi',
  'suc-khoe/giam-dau': 'Health/PainManagement',
  'suc-khoe/trieu-chung': 'Health/Symptoms',
  'suc-khoe/kien-thuc-suc-khoe': 'Health/GeneralHealthKnowledge',
  'the-duc-the-thao': 'healthfitness',
  'the-duc-the-thao/cardio-suc-ben': 'healthfitness/CardioEndurance',
  'the-duc-the-thao/tang-cuong-suc-manh': 'healthfitness/StrengthTraining',
  'the-duc-the-thao/chan-thuong-the-thao': 'healthfitness/ExerciseSafetyTips',
  'the-duc-the-thao/dong-luc-tap-luyen': 'healthfitness/FitnessMotivation',
  'the-duc-the-thao/hoat-dong-the-chat-khac':
    'healthfitness/OtherFitnessActivities',
  'the-duc-the-thao/bai-tap-giam-can': 'healthfitness/WeightLossExercises',
  'the-duc-the-thao/can-bang-deo-dai': 'healthfitness/BalanceFlexibility',
  'lao-hoa-lanh-manh': 'healthyaging',
  'lao-hoa-lanh-manh/qua-trinh-lao-hoa': 'HealthyAging/ActiveAging',
  'lao-hoa-lanh-manh/nao-bo-lao-hoa': 'HealthyAging/AgingMind',
  'lao-hoa-lanh-manh/co-the-lao-hoa': 'HealthyAging/AgingBody',
  'lao-hoa-lanh-manh/dinh-duong-cho-nguoi-cao-tuoi':
    'HealthyAging/NutritionForAging',
  'lao-hoa-lanh-manh/van-de-lao-hoa': 'HealthyAging/CommonAgingConditions',
  'an-uong-lanh-manh': 'healthyeating',
  'an-uong-lanh-manh/beo-phi': 'healthyeating/Obesity',
  'an-uong-lanh-manh/cong-thuc-nau-an-tot-cho-suc-khoe':
    'healthyeating/HealthyRecipes',
  'an-uong-lanh-manh/che-do-an-kieng-va-quan-ly-can-nang':
    'healthyeating/DietWeightLoss',
  'an-uong-lanh-manh/thong-tin-dinh-duong': 'healthyeating/NutritionFacts',
  'an-uong-lanh-manh/che-do-dinh-duong-dac-biet': 'healthyeating/SpecialDiets',
  'an-uong-lanh-manh/dinh-duong-khi-tap-luyen': 'healthyeating/SportsNutrition',
  'an-uong-lanh-manh/bi-quyet-an-uong-lanh-manh':
    'healthyeating/OtherhealthyeatingTips',
  'thoi-quen-lanh-manh': 'HealthyHabits',
  'thoi-quen-lanh-manh/so-cuu-va-phong-ngua': 'HealthyHabits/FirstAid',
  'thoi-quen-lanh-manh/bo-thuoc-la': 'HealthyHabits/QuitSmoking',
  'thoi-quen-lanh-manh/ve-sinh': 'HealthyHabits/GeneralHygiene',
  'thoi-quen-lanh-manh/song-xanh': 'HealthyHabits/GreenLiving',
  'tam-ly-tam-than': 'healthymind',
  'tam-ly-tam-than/nghien': 'healthymind/Addiction',
  'tam-ly-tam-than/roi-loan-lo-au': 'healthymind/AnxietyDisorder',
  'tam-ly-tam-than/tram-cam-roi-loan-cam-xuc': 'healthymind/MoodDisorder',
  'tam-ly-tam-than/phong-ngua-tu-tu': 'healthymind/SuicidePrevention',
  'tam-ly-tam-than/quan-ly-cang-thang': 'healthymind/StressManagement',
  'tam-ly-tam-than/roi-loan-an-uong': 'healthymind/EatingDisorders',
  'tam-ly-tam-than/moi-quan-he': 'healthymind/HealthyRelationships',
  'tam-ly-tam-than/roi-loan-phat-trien': 'healthymind/Developmental Disorder',
  'tam-ly-tam-than/van-de-tam-ly-tam-than':
    'healthymind/OtherMentalHealthIssues',
  'giac-ngu': 'healthysleep',
  'giac-ngu/giac-ngu-ngon': 'healthysleep/AGoodNightsSleep',
  'giac-ngu/ngung-tho-khi-ngu': 'healthysleep/SleepApnea',
  'giac-ngu/mat-ngu': 'healthysleep/Insomnia',
  'giac-ngu/roi-loan-giac-ngu': 'healthysleep/SleepDisorders',
  'benh-tim-mach': 'HeartHealth',
  'benh-tim-mach/cao-huyet-ap-tang-huyet-ap': 'HeartHealth/Hypertension',
  'benh-tim-mach/benh-tim': 'HeartHealth/HeartDisease',
  'benh-tim-mach/tim-nhiem-trung': 'HeartHealth/HeartInfections',
  'benh-tim-mach/cholesterol': 'HeartHealth/Cholesterol',
  'benh-tim-mach/suy-tim': 'HeartHealth/HeartFailure',
  'benh-tim-mach/dong-mach-vanh': 'HeartHealth/CoronaryArteryDisease',
  'benh-tim-mach/roi-loan-nhip-tim': 'HeartHealth/HeartArrhythmias',
  'benh-tim-mach/benh-tim-bam-sinh': 'HeartHealth/CongenitalHeartDisease',
  'benh-tim-mach/van-tim': 'HeartHealth/HeartValve',
  'benh-tim-mach/xo-vua-dong-mach': 'HeartHealth/Atherosclerosis',
  'benh-tim-mach/benh-co-tim': 'HeartHealth/Cardiomyopathy',
  'benh-tim-mach/van-de-tim-mach-khac': 'HeartHealth/OtherCardiovascularIssues',
  'duoc-lieu': 'herbalalternatives',
  'duoc-lieu/thao-duoc': 'herbalalternatives/Herbal',
  'duoc-lieu/duoc-lieu-khac': 'herbalalternatives/Alternatives',
  'benh-truyen-nhiem': 'InfectiousDiseases',
  'benh-truyen-nhiem/coronavirus': 'InfectiousDiseases/Coronavirus',
  'benh-truyen-nhiem/nhiem-trung-duong-ho-hap':
    'InfectiousDiseases/RespiratoryInfections',
  'benh-truyen-nhiem/nhiem-trung-duong-an-uong':
    'InfectiousDiseases/FoodborneInfections',
  'benh-truyen-nhiem/van-de-nhiem-khuan-khac':
    'InfectiousDiseases/OtherBacterialInfections',
  'benh-truyen-nhiem/nhiem-trung-duong-khong-khi':
    'InfectiousDiseases/AirborneInfections',
  'benh-truyen-nhiem/zika': 'InfectiousDiseases/Zika',
  'benh-truyen-nhiem/sot-xuat-huyet': 'InfectiousDiseases/Dengue',
  'benh-truyen-nhiem/nhiem-trung-do-con-trung':
    'InfectiousDiseases/InfectionsFromInsects',
  'benh-truyen-nhiem/benh-truyen-nhiem-khac':
    'InfectiousDiseases/OtherViralInfections',
  'benh-truyen-nhiem/viem-mang-nao': 'InfectiousDiseases/Meningitis',
  'benh-truyen-nhiem/mun-rop': 'InfectiousDiseases/Herpes',
  'benh-truyen-nhiem/thuong-han': 'InfectiousDiseases/TyphoidFever',
  'suc-khoe-nam-gioi': 'MensHealth',
  'suc-khoe-nam-gioi/van-de-hormone-nam-gioi': 'MensHealth/HormoneIssues',
  'suc-khoe-nam-gioi/roi-loan-cuong-duong': 'MensHealth/ErectileDisfunction',
  'suc-khoe-nam-gioi/cong-duong-vat': 'MensHealth/PeyroniesDisease',
  'suc-khoe-nam-gioi/van-de-suc-khoe-nam-gioi-khac': 'MensHealth/HealthIssues',
  'suc-khoe-nam-gioi/suc-khoe-duong-vat': 'MensHealth/PenisHealth',
  'suc-khoe-rang-mieng': 'OralHealth',
  'suc-khoe-rang-mieng/cham-soc-rang-mieng': 'OralHealth/OralCare',
  'suc-khoe-rang-mieng/viem-nuou-nha-chu': 'OralHealth/GumMouth',
  'suc-khoe-rang-mieng/van-de-ve-rang': 'OralHealth/DentalConditions',
  'suc-khoe-rang-mieng/nha-khoa-tham-my': 'OralHealth/CosmeticDentistry',
  'suc-khoe-rang-mieng/chinh-nha': 'OralHealth/Orthodontics',
  'suc-khoe-rang-mieng/nha-khoa-nhi': 'OralHealth/PediatricDentistry',
  'suc-khoe-rang-mieng/van-de-rang-mieng-khac':
    'OralHealth/OtherOralHealthIssues',
  'benh-co-xuong-khop': 'Musculoskeletal',
  'benh-co-xuong-khop/viem-khop': 'Musculoskeletal/Arthritis',
  'benh-co-xuong-khop/loang-xuong': 'Musculoskeletal/Osteoporosis',
  'benh-co-xuong-khop/chan-thuong-chinh-hinh':
    'Musculoskeletal/OrthopedicSurgery',
  'benh-co-xuong-khop/ran-xuong-gay-xuong':
    'Musculoskeletal/FracturesBrokenBones',
  'benh-co-xuong-khop/dau-co-xuong-khop': 'Musculoskeletal/MusculoskeletalPain',
  'benh-co-xuong-khop/van-de-khop-day-chang-khac':
    'Musculoskeletal/OtherJointTendonDiseases',
  'benh-co-xuong-khop/van-de-xuong-khac': 'Musculoskeletal/OtherBoneDiseases',
  'nuoi-day-con': 'parenting',
  'nuoi-day-con/be-0-1-tuoi': 'parenting/Baby',
  'nuoi-day-con/be-0-1-tuoi/dinh-duong-cho-tre': 'parenting/Baby/BabyNutrition',
  'nuoi-day-con/be-0-1-tuoi/nam-dau-doi-cua-be':
    'parenting/Baby/BabysFirstYear',
  'nuoi-day-con/be-0-1-tuoi/nuoi-con-bang-sua-me':
    'parenting/Baby/Breastfeeding',
  'nuoi-day-con/be-0-1-tuoi/cham-soc-be': 'parenting/Baby/BabyCare',
  'nuoi-day-con/be-0-1-tuoi/tre-sinh-non': 'parenting/Baby/PrematureBabies',
  'nuoi-day-con/tre-1-5-tuoi': 'parenting/ToddlerPreschooler',
  'nuoi-day-con/tre-1-5-tuoi/cot-moc-1-5-tuoi':
    'parenting/ToddlerPreschooler/Milestones',
  'nuoi-day-con/tre-1-5-tuoi/su-phat-trien-tre-1-5-tuoi':
    'parenting/ToddlerPreschooler/GrowthDevelopment',
  'nuoi-day-con/tre-1-5-tuoi/dinh-duong-cho-tre-1-5-tuoi':
    'parenting/ToddlerPreschooler/Nutrition',
  'nuoi-day-con/tre-di-hoc': 'parenting/SchoolAgeChildren',
  'nuoi-day-con/tre-di-hoc/cot-moc-tre-di-hoc':
    'parenting/SchoolAgeChildren/Milestones',
  'nuoi-day-con/tre-di-hoc/su-phat-trien-tre-di-hoc':
    'parenting/SchoolAgeChildren/GrowthDevelopment',
  'nuoi-day-con/tre-di-hoc/dinh-duong-tre-di-hoc':
    'parenting/SchoolAgeChildren/Nutrition',
  'nuoi-day-con/nhi-khoa': 'parenting/ChildHealth',
  'nuoi-day-con/nhi-khoa/tiem-phong-cho-tre': 'parenting/ChildHealth/Vaccines',
  'nuoi-day-con/nhi-khoa/trieu-chung-thuong-gap-tre-em':
    'parenting/ChildHealth/CommonSymptoms',
  'nuoi-day-con/nhi-khoa/benh-truyen-nhiem-tre-em':
    'parenting/ChildHealth/InfectiousDiseases',
  'nuoi-day-con/nhi-khoa/suy-dinh-duong-tre-em':
    'parenting/ChildHealth/Malnutrition',
  'nuoi-day-con/nhi-khoa/roi-loan-hanh-vi-phat-trien':
    'parenting/ChildHealth/BehavioralDevelopmentalDisorders',
  'nuoi-day-con/nhi-khoa/van-de-than-kinh-tre-em':
    'parenting/ChildHealth/NeurologicalDiseases',
  'nuoi-day-con/nhi-khoa/van-de-tieu-hoa-tre-em':
    'parenting/ChildHealth/DigestiveProblems',
  'nuoi-day-con/nhi-khoa/van-de-da-tre-em':
    'parenting/ChildHealth/SkinDiseases',
  'nuoi-day-con/nhi-khoa/van-de-ho-hap-tre-em':
    'parenting/ChildHealth/RespiratoryDiseases',
  'nuoi-day-con/nhi-khoa/van-de-nhi-khoa-khac':
    'parenting/ChildHealth/OtherChildHealthIssues',
  'nuoi-day-con/tuoi-day-thi': 'parenting/Adolescents',
  'nuoi-day-con/tuoi-day-thi/cot-moc-tuoi-day-thi':
    'parenting/Adolescents/MilestonesDevelopment',
  'nuoi-day-con/tuoi-day-thi/tam-ly-tuoi-day-thi':
    'parenting/Adolescents/MentalHealth',
  'nuoi-day-con/tuoi-day-thi/suc-khoe-tuoi-day-thi':
    'parenting/Adolescents/Health',
  'mang-thai/chuan-bi-mang-thai': 'pregnancy/GettingPregnant',
  'mang-thai/chuan-bi-mang-thai/hiem-muon-vo-sinh':
    'pregnancy/GettingPregnant/FertilityProblemsTreatment',
  'mang-thai/chuan-bi-mang-thai/kinh-nghiem-thu-thai':
    'pregnancy/GettingPregnant/RealStories',
  'mang-thai/chuan-bi-mang-thai/chu-de-thu-thai-khac':
    'pregnancy/GettingPregnant/OtherConceptionTopics',
  'mang-thai/chuan-bi-mang-thai/chuan-bi-tien-san':
    'pregnancy/GettingPregnant/PregnantPreparation',
  'mang-thai/thai-ky': 'pregnancy/BeingPregnant',
  'mang-thai/thai-ky/cham-soc-me-bau': 'pregnancy/BeingPregnant/PrenatalCare',
  'mang-thai/thai-ky/tam-ca-nguyet-1': 'pregnancy/BeingPregnant/FirstTrimester',
  'mang-thai/thai-ky/tam-ca-nguyet-2':
    'pregnancy/BeingPregnant/SecondTrimester',
  'mang-thai/thai-ky/tam-ca-nguyet-3': 'pregnancy/BeingPregnant/ThirdTrimester',
  'mang-thai/thai-ky/suc-khoe-khi-mang-thai':
    'pregnancy/BeingPregnant/pregnancyProblems',
  'mang-thai/thai-ky/cau-chuyen-me-bau': 'pregnancy/BeingPregnant/MyStory',
  'mang-thai/di-sinh': 'pregnancy/GivingBirth',
  'mang-thai/di-sinh/chuan-bi-di-sinh': 'pregnancy/GivingBirth/Preparing',
  'mang-thai/di-sinh/chuyen-da-sinh-no': 'pregnancy/GivingBirth/LaborDelivery',
  'mang-thai/di-sinh/bien-chung-khi-sinh':
    'pregnancy/GivingBirth/Complications',
  'mang-thai/di-sinh/kinh-nghiem-di-sinh': 'pregnancy/GivingBirth/BirthStories',
  'mang-thai/cham-soc-me-sau-sinh': 'pregnancy/MotherCare',
  'mang-thai/cham-soc-me-sau-sinh/hau-san':
    'pregnancy/MotherCare/PostpartumPeriod',
  'mang-thai/cham-soc-me-sau-sinh/khoe-dep-sau-sinh':
    'pregnancy/MotherCare/PostpartumSelfcare',
  'mang-thai/cham-soc-me-sau-sinh/tam-ly-sau-sinh':
    'pregnancy/MotherCare/MentalHealth',
  'mang-thai/cham-soc-me-sau-sinh/kinh-nghiem-sau-sinh':
    'pregnancy/MotherCare/WomansVoice',
  'mang-thai/cham-soc-me-sau-sinh/chu-de-sau-sinh-khac':
    'pregnancy/MotherCare/OtherMothercareTopics',
  'ho-va-benh-duong-ho-hap': 'respiratoryhealth',
  'ho-va-benh-duong-ho-hap/hen-suyen': 'respiratoryhealth/Asthma',
  'ho-va-benh-duong-ho-hap/viem-phe-quan-man-tinh':
    'respiratoryhealth/ChronicBronchitis',
  'ho-va-benh-duong-ho-hap/khi-phe-thung': 'respiratoryhealth/Emphysema',
  'ho-va-benh-duong-ho-hap/gian-phe-quan': 'respiratoryhealth/Bronchiectasis',
  'ho-va-benh-duong-ho-hap/benh-cum': 'respiratoryhealth/Influenza',
  'ho-va-benh-duong-ho-hap/benh-lao': 'respiratoryhealth/Tuberculosis',
  'ho-va-benh-duong-ho-hap/viem-phoi': 'respiratoryhealth/Pneumonia',
  'ho-va-benh-duong-ho-hap/u-hat-phoi': 'respiratoryhealth/Lung',
  'ho-va-benh-duong-ho-hap/cam-lanh': 'respiratoryhealth/Cold',
  'ho-va-benh-duong-ho-hap/viem-phe-quan': 'respiratoryhealth/Bronchitis',
  'ho-va-benh-duong-ho-hap/thuyen-tac-phoi':
    'respiratoryhealth/PulmonaryEmbolism',
  'ho-va-benh-duong-ho-hap/cac-van-de-ho-hap-khac':
    'respiratoryhealth/OtherRespiratoryIssues',
  'suc-khoe-tinh-duc': 'SexualWellness',
  'suc-khoe-tinh-duc/hiv-aids': 'SexualWellness/HIVAIDS',
  'suc-khoe-tinh-duc/ngua-thai': 'SexualWellness/Contraception',
  'suc-khoe-tinh-duc/tinh-duc-an-toan': 'SexualWellness/SafeSex',
  'suc-khoe-tinh-duc/benh-chlamydia': 'SexualWellness/Chlamydia',
  'suc-khoe-tinh-duc/benh-giang-mai': 'SexualWellness/Syphilis',
  'suc-khoe-tinh-duc/benh-lau': 'SexualWellness/Gonorrhea',
  'suc-khoe-tinh-duc/mun-rop-sinh-duc': 'SexualWellness/GenitalHerpes',
  'suc-khoe-tinh-duc/hpv': 'SexualWellness/HPV',
  'suc-khoe-tinh-duc/benh-trichomonas': 'SexualWellness/Trichomonas',
  'suc-khoe-tinh-duc/benh-tinh-duc-khac': 'SexualWellness/STIsSTDs',
  'suc-khoe-tinh-duc/bi-quyet-quan-he': 'SexualWellness/SexTips',
  'da-lieu': 'SkinHealth',
  'da-lieu/cham-soc-da': 'SkinHealth/SkinCareCleansing',
  'da-lieu/tri-mun': 'SkinHealth/Acne',
  'da-lieu/cham-soc-mong': 'SkinHealth/NailCare',
  'da-lieu/cham-soc-toc-da-dau': 'SkinHealth/HairScalpCare',
  'da-lieu/nhiem-trung-da': 'SkinHealth/InfectiousSkin',
  'da-lieu/vay-nen': 'SkinHealth/Psoriasis',
  'da-lieu/viem-da': 'SkinHealth/Dermatitis',
  'da-lieu/van-de-ve-da': 'SkinHealth/OtherSkinDiseases',
  'benh-than-va-duong-tiet-nieu': 'UrologicalHealth',
  'benh-than-va-duong-tiet-nieu/benh-than': 'UrologicalHealth/KidneyDisease',
  'benh-than-va-duong-tiet-nieu/benh-bang-quang':
    'UrologicalHealth/BladderProblems',
  'benh-than-va-duong-tiet-nieu/soi-duong-tiet-nieu':
    'UrologicalHealth/UrinaryTrackStones',
  'benh-than-va-duong-tiet-nieu/tieu-khong-tu-chu':
    'UrologicalHealth/UrinaryIncontinence',
  'benh-than-va-duong-tiet-nieu/nhiem-trung-duong-tieu': 'UrologicalHealth/UTI',
  'benh-than-va-duong-tiet-nieu/van-de-tiet-nieu-khac':
    'UrologicalHealth/OtherUrologicalIssues',
  'benh-than-va-duong-tiet-nieu/tuyen-tien-liet':
    'UrologicalHealth/ProstateHealth',
  'suc-khoe-phu-nu': 'womenshealth',
  'suc-khoe-phu-nu/u-xo-tu-cung': 'womenshealth/MyomaCysts',
  'suc-khoe-phu-nu/benh-tuyen-giap': 'womenshealth/FemaleHormonalImbalance',
  'suc-khoe-phu-nu/buong-trung-da-nang': 'womenshealth/PCOS',
  'suc-khoe-phu-nu/viem-am-dao': 'womenshealth/Vaginitis',
  'suc-khoe-phu-nu/van-de-vung-chau': 'womenshealth/PelvicRelatedIssue',
  'suc-khoe-phu-nu/man-kinh': 'womenshealth/Menopause',
  'suc-khoe-phu-nu/sang-loc-kiem-tra-phu-khoa': 'womenshealth/ScreeningTests',
  'suc-khoe-phu-nu/chu-ky-kinh-nguyet': 'womenshealth/Menstruation',
  'suc-khoe-phu-nu/van-de-phu-khoa-khac': 'womenshealth/womenshealthIssue',
  uncategorized: '',
  'kiem-tra-suc-khoe': 'HealthTools',
  'kiem-tra-suc-khoe/cach-tinh-chi-so-bmi': 'HealthTools/BMI',
  'kiem-tra-suc-khoe/tinh-chi-so-bmr': 'HealthTools/BMR',
  'kiem-tra-suc-khoe/tinh-ngay-rung-trung': 'HealthTools/OvulationCalculator',
  'kiem-tra-suc-khoe/cach-tinh-nhip-tim-muc-tieu': 'HealthTools/HeartRate',
  'kiem-tra-suc-khoe/cach-tinh-nong-do-con-trong-mau-bac': 'HealthTools/BAC',
  'kiem-tra-suc-khoe/cong-cu-tinh-chi-phi-hut-thuoc-la':
    'HealthTools/SmokingCostCalculator',
  'kiem-tra-suc-khoe/phan-tre-so-sinh-nhu-the-nao-la-tot':
    'HealthTools/BabysFeces',
  'kiem-tra-suc-khoe/cong-cu-tinh-can-nang-khi-mang-thai':
    'HealthTools/PregnancyWeight',
  'kiem-tra-suc-khoe/ty-le-dot-chay-calo': 'HealthTools/CaloriesCalculator',
  'kiem-tra-suc-khoe/cong-cu-tinh-ngay-du-sinh':
    'HealthTools/BirthDateCalculator',
  'kiem-tra-suc-khoe/lich-tiem-chung': 'HealthTools/ImmunizationSchedule',
  'kiem-tra-suc-khoe/ket-qua-lich-tiem-chung':
    'HealthTools/ImmunizationReminder',

  // NEW MB Mapping
  'chuan-bi-mang-thai': 'GettingPregnant',
  'chuan-bi-mang-thai/suc-khoe-va-dinh-duong': 'GettingPregnant/Nutrition',
  'chuan-bi-mang-thai/thu-thai': 'GettingPregnant/Conception',
  'chuan-bi-mang-thai/vo-sinh-hiem-muon': 'GettingPregnant/Conception',
  'gia-dinh': 'Family',
  'gia-dinh/suc-khoe-gia-dinh': 'Family/HealthCare',
  'gia-dinh/giai-tri': 'Family/Entertain',
  'gia-dinh/nau-an-ngon': 'Family/DeliciousRecipes',
  'gia-dinh/tai-chinh-bao-hiem': 'Family/FinanceInsurance',
  'gia-dinh/thuong-thuc-gia-dinh': 'Family/FamilyRoutine',
  'gia-dinh/tin-tuc-moi-ngay': 'Family/News',
  'gia-dinh/tinh-cam-gia-dinh': 'Family/FamilyLove',
  'mang-thai': 'Pregnancy',
  'mang-thai/3-thang-cuoi': 'Pregnancy/LastThreeMonths',
  'mang-thai/3-thang-dau': 'Pregnancy/FirstThreeMonths',
  'mang-thai/3-thang-giua': 'Pregnancy/MiddleThreeMonths',
  'mang-thai/bien-chung-thai-ky': 'Pregnancy/PregnancyComplication',
  'mang-thai/cham-soc-me-bau': 'Pregnancy/PregnantMotherCare',
  'mang-thai/chuyen-da-sinh-no': 'Pregnancy/LaborBirth',
  'mang-thai/don-con-chao-doi': 'Pregnancy/WelcomingBaby',
  'mang-thai/say-thai-thai-luu': 'Pregnancy/Miscarriage',
  'nuoi-day-con-cai': 'Parenting',
  'nuoi-day-con-cai/chon-truong': 'Parenting/SelectSchool',
  'nuoi-day-con-cai/day-con': 'Parenting/TeachMe',
  'nuoi-day-con-cai/hat-giong-tam-hon': 'Parenting/BeautifulLife',
  'nuoi-day-con-cai/so-cap-cuu': 'Parenting/FirstAid',
  'sau-khi-sinh': 'Postpartum',
  'sau-khi-sinh/chu-de-sau-sinh-khac': 'Postpartum/OtherPostpartumTopics',
  'sau-khi-sinh/dinh-duong-sau-sinh': 'Postpartum/PostpartumNutrition',
  'sau-khi-sinh/giai-doan-hau-san': 'Postpartum/PostpartumPeriod',
  'sau-khi-sinh/tram-cam-sau-sinh': 'Postpartum/PostpartumDepression',
  'sau-khi-sinh/voc-dang': 'Postpartum/Body',
  'su-phat-trien-cua-tre': 'ChildDevelopment',
  'su-phat-trien-cua-tre/nam-dau-doi-cua-be': 'ChildDevelopment/BabyFIrstYear',
  'su-phat-trien-cua-tre/nam-dau-doi-cua-be/cham-soc-be-so-sinh':
    'ChildDevelopment/BabyFIrstYear/Babycare',
  'su-phat-trien-cua-tre/nam-dau-doi-cua-be/cho-con-bu':
    'ChildDevelopment/BabyFIrstYear/Breastfeeding',
  'su-phat-trien-cua-tre/nam-dau-doi-cua-be/cot-moc-phat-trien-be-so-sinh':
    'ChildDevelopment/BabyFIrstYear/DevelopmentMilestones',
  'su-phat-trien-cua-tre/nam-dau-doi-cua-be/dinh-duong-be-so-sinh':
    'ChildDevelopment/BabyFIrstYear/NutritionforBabies',
  'su-phat-trien-cua-tre/nam-dau-doi-cua-be/suc-khoe-be-so-sinh':
    'ChildDevelopment/BabyFIrstYear/NewbornBabyHealth',
  'su-phat-trien-cua-tre/suc-khoe-tre-em': 'ChildDevelopment/ChildHealth',
  'su-phat-trien-cua-tre/suc-khoe-tre-em/benh-da-lieu':
    'ChildDevelopment/ChildHealth/VenerealDiseases',
  'su-phat-trien-cua-tre/suc-khoe-tre-em/benh-duong-ho-hap-o-tre':
    'ChildDevelopment/ChildHealth/ResporatoryDiseases',
  'su-phat-trien-cua-tre/suc-khoe-tre-em/van-de-suc-khoe-tre-em-khac':
    'ChildDevelopment/ChildHealth/OtherChildHealthProblems',
  'su-phat-trien-cua-tre/suc-khoe-tre-em/van-de-than-kinh-o-tre':
    'ChildDevelopment/ChildHealth/NervousProblems',
  'su-phat-trien-cua-tre/suc-khoe-tre-em/roi-loan-hanh-vi-va-phat-trien':
    'ChildDevelopment/ChildHealth/BehavioralandDevelopmentalDisorders',
  'su-phat-trien-cua-tre/suc-khoe-tre-em/suy-dinh-duong':
    'ChildDevelopment/ChildHealth/Malnutrition',
  'su-phat-trien-cua-tre/suc-khoe-tre-em/tiem-phong':
    'ChildDevelopment/ChildHealth/Vaccination',
  'su-phat-trien-cua-tre/suc-khoe-tre-em/trieu-chung-va-benh-pho-bien':
    'ChildDevelopment/ChildHealth/CommonSymptomsandDiseases',
  'su-phat-trien-cua-tre/suc-khoe-tre-em/van-de-tieu-hoa-o-tre':
    'ChildDevelopment/ChildHealth/DigestiveProblems',
  'su-phat-trien-cua-tre/tre-tap-di-mau-giao': 'ChildDevelopment/Toddlers',
  'su-phat-trien-cua-tre/tre-tap-di-mau-giao/cham-soc-tre-tap-di-mau-giao':
    'ChildDevelopment/Toddlers/BabyCare',
  'su-phat-trien-cua-tre/tre-tap-di-mau-giao/moc-phat-trien-cua-tre-tap-di-mau-giao':
    'ChildDevelopment/Toddlers/DevelopmentalMilestonesforToddlersandPreschoolers',
  'su-phat-trien-cua-tre/tre-tap-di-mau-giao/dinh-duong-tre-tap-di-mau-giao':
    'ChildDevelopment/Toddlers/NutritionsforToddlersandPreschoolers',
  'su-phat-trien-cua-tre/tre-tieu-hoc-6-10-tuoi':
    'ChildDevelopment/PrimarySchoolChildren',
  'su-phat-trien-cua-tre/tre-tieu-hoc-6-10-tuoi/cham-soc-tre-tre-tieu-hoc':
    'ChildDevelopment/PrimarySchoolChildren/BabyCare',
  'su-phat-trien-cua-tre/tre-tieu-hoc-6-10-tuoi/cot-moc-phat-trien-tre-tieu-hoc':
    'ChildDevelopment/PrimarySchoolChildren/DevelopmentMilestones',
  'su-phat-trien-cua-tre/tre-tieu-hoc-6-10-tuoi/dinh-duong-tre-tieu-hoc':
    'ChildDevelopment/PrimarySchoolChildren/NutritionsforPrimarySchoolChildren',
  'su-phat-trien-cua-tre/tuoi-day-thi-10-15-tuoi': 'ChildDevelopment/Teenager',
  'su-phat-trien-cua-tre/tuoi-day-thi-10-15-tuoi/suc-khoe-tuoi-day-thi':
    'ChildDevelopment/Teenager/PubertyHealth',
  'su-phat-trien-cua-tre/tuoi-day-thi-10-15-tuoi/tuoi-day-thi-o-nu':
    'ChildDevelopment/Teenager/FemalePuberty',
  'su-phat-trien-cua-tre/tuoi-day-thi-10-15-tuoi/tuoi-day-thi-o-nam':
    'ChildDevelopment/Teenager/MalePuberty',
}

const spotlightViVN: {
  [k: string]: string
} = {
  'tang-cuong-suc-khoe-duong-ruot': 'Spotlight/GutHealth',
  'roi-loan-nhan-thuc-va-suc-khoe-nao-bo': 'Spotlight/MemoryDecline',
  'suc-khoe-covid-19': 'Spotlight/Covid19Fact',
  'tuan-le-glocom-the-gioi': 'Spotlight/Glaucoma',
  'vi-suc-khoe-phu-nu': 'Spotlight/WomensHealth',
  'ngay-the-gioi-phong-chong-ung-thu': 'Spotlight/Cancer',
  'hieu-ve-bao-hiem-quan-ly-rui-ro-bao-ve-ban-than-va-gia-dinh':
    'Spotlight/Insurance',
  '2022-chon-khoe': 'Spotlight/NewNormal',
  'thang-nang-cao-nhan-thuc-ve-sinh-mo': 'Spotlight/Caesarean',
  'tuan-le-tiem-chung-the-gioi': 'Spotlight/Vaccinations',
}
const spotlightThTH: {
  [k: string]: string
} = {
  'เรื่องต้องรู้-สมองกับผู้สูงวัย': 'Spotlight/HealthTipsForElderly',
  'ข้อมูลและข่าวสารล่าสุดเกี่ยวกับ-โควิด-19': 'Spotlight/Covid19Fact',
  '28-กรกฎาคม-วันตับอักเสบโลก': 'Spotlight/HepatitisFact',
  การใช้ชีวิตร่วมกับโรคภูมิต้านตนเอง: 'Spotlight/AutoimmuneDisease',
  วิธีใช้ชีวิตร่วมกับโรคปอดอุดกั้นเรื้อรัง: 'Spotlight/COPDFact',
  'การรับมือกับโรคเบาหวานและโรคต่อมไร้ท่ออื่น-ๆ': 'Spotlight/DiabetesFact',
}

export const getLocaleAdMappingFromSlug = (locale: string, slug: string) => {
  const cleanedSlug = slug.split('/').filter(Boolean).join('/')
  switch (locale) {
    case 'km-KH':
      return kmKH[cleanedSlug]
    case 'hi-IN':
      return hiIN[cleanedSlug]
    case 'th-TH':
      return th[cleanedSlug]
    case 'id-ID':
      return idID[cleanedSlug]
    case 'ms-MY':
      return msMY[cleanedSlug]
    case 'vi-VN':
      return viVN[cleanedSlug]
    default:
      return null
  }
}

export const getSpotlightLocaleAdMappingFromSlug = (
  locale: string,
  spotlightSlug: string,
) => {
  const cleanedSlug = spotlightSlug.split('/').filter(Boolean).join('/')
  switch (locale) {
    case 'vi-VN':
      return spotlightViVN[cleanedSlug]
    case 'th-TH':
      return spotlightThTH[cleanedSlug]
    default:
      return null
  }
}

export const getLocaleAdMappingFromSlugNonRedundant = (
  locale: string,
  slug: string,
) => {
  const cleanedSlug = slug.split('/').filter(Boolean).join('/')
  switch (locale) {
    case 'id-ID':
      return idID_nonRedundent[cleanedSlug]
    default:
      return null
  }
}
